export default {
  title: {
    payErrorJump: 'Cashier'
  },
  msg: {
    title: 'Message'
  },
  rate: {
    title: 'IDD Tariff',
    searchNoResult: 'no result',
    searchTip: 'search',
    tableTitleLeft: 'Country / Region',
    tableTitleCenter: 'Code',
    tableTitleRight: 'Charge',
    tableTitleRightUnit: '(HKD/min)',
    cancel: 'cancel',
    tipTitle: 'Remarks',
    tip1: '1. The following charges in calculated in Hong Kong dollars. The IDD charges will be calculated by minute basis.',
    tip2: '2. In addition to IDD rates,  China or Hong Kong/China call airtime charges is also applied.',
    tip3: '3. Guangzhou Multibyte Info Service Limited reserves the right to make the final decision on the following terms and conditions. Charges are subject to change without notice.'
  },
  company: {
    title: 'About Multibyte',
    ERCodeDesc: 'Multibyte Info Group',
    info: 'Multibyte Info Technology Ltd. was co-founded in 2000. It has branches in Guangzhou and Hong Kong. MB was authorized the Mobile Virtual Network Operator (“MVNO”) services license (license number: 1687) by Hong Kong Communications Authority and MB was also authorized the "Value-added telecommunications business license of the People\'s Republic of China” (license number: A1-20184242) by Ministry of Industry and Information Technology.',
    gotoMB: 'Enter Multibyte'
  },
  privacyText: {
    title: 'Privacy Policy of eSender',
    summary:
      {
        title: 'Summary',
        text: 'Guangzhou Multibyte Info Service Limited. ("eSender" or "us" or "our" or other similar pronouns) take your privacy very seriously. Please read the following to learn more about our privacy policy ("Policy"). This policy details how we receive collect and use information about the services provided on the eSender. (The above is collectively referred to as "services"). When using this service, it means that you accept the policies and practices described in this policy because this policy may be modified from time to time. Every time you use the service you agree and expressly agree that we collect use and disclose the information you provide in accordance with the provisions of this policy.'
      },
    one: {
      title: '1.\tWhat information will we collect from you?',
      text1: 'We will collect your data if you set up an eSender account and use the services provided by us. We will collect your',
      text2: 'device model operating system location information mobile phone reading and writing microphone address book camera unique device identifier login IP address access to the network type and status network quality data operation Logs and nicknames are basic information that must be collected to provide services',
      text3: '，At the same time, you can provide more information to make your personal data more refined and popular. We will store the collected information properly and use it with caution。'
    },
    two: {
      title: '2. SDK directory of third-party vendors',
      substile1: '1) Jiguang SDK used for notification push',
      text2: 'A.Obtain permission:：',
      text3: '•Get your equipment information',
      text4: '•Get your read-write external storage',
      text5: '•Check your network connection status',
      text6: 'B.Purpose of use',
      text7: '•Notification push',
      text8: 'C.Processing method',
      text9: '•Use replacement, de-identification, encryption and anonymization to desensitize personal information',
      text10: 'D.Jiguang Privacy Agreement',
      subtitle2: '2)Umeng U-Share SDK',
      text20: 'In order to provide you with one-click sharing service our product integrates U-Share SDK. U-Share SDK needs to collect your device Mac address unique device identification code (IMEI/android ID/IDFA/OPENUDID/GUID, SIM card, IMSI information) and the social account public information you need to share in order to complete the one-click sharing service. And through the geographic location calibration report data accuracy provide basic anti-cheating services. For your information security we have entered into data security and confidentiality agreements with third-party SDK service providers and these companies will strictly abide by our data privacy and security requirements. Unless we have your consent, we will not share your personally identifiable information with them. In order for you to better understand the type and purpose of the data collected by [Umeng+] and how to protect your personal information.',
      text21: 'you can visit',
      text22: 'to understand the privacy policy of [Umeng+] .',
      subtitle3: '3) Tencent Bugly SDK',
      text30: 'In order to better troubleshoot crash issues and help improve the stability of the app, our product integrates the Tencent Bugly SDK. The Tencent Bugly SDK needs to collect information such as Android system version, vendor system version, and memory space usage. For your information security, we have entered into data security and confidentiality agreements with third-party SDK service providers, and these companies will strictly comply with our data privacy and security requirements. Unless we obtain your consent, we will not share your personally identifiable information with you. To facilitate your better understanding of the types and purposes of data collected by the Bugly SDK, as well as how to protect your personal information.',
      text31: 'You can visit ',
      text32: ' to understand the Bugly SDK Privacy Statement.'
    },
    three: {
      title: '3.How will we use your information?',
      text1: 'We will use your information to provide your eSender service allow you to communicate with other users and use the functions of the eSender public platform. We will use your information to set up accounts facilitate communication provide support allow you to access eSender features and improve eSender services. E-Sender will use the WeChat application you use to verify and protect your account. It will also be used for important management factors and eSender will not use these communication channels for sales or marketing.'
    },
    four: {
      title: '4.Who will we share your information with?',
      text1: 'We will use third-party support services such as using the WeChat public platform to provide account verification services. When we use these third-party services to process or store your information, and it will be limited to the purposes set out in this policy. We will also share your information with Multi-byte related group companies and share it in accordance with legal requirements. Except for the purposes listed above eSender will not share your information with third parties without your prior express consent. Any third-party service provider (selected by us) with which we share user information will provide the same or the same level of user information protection standards as described in this policy.'
    },
    five: {
      title: '5.How long will we keep your information? ',
      text1: 'The time we retain your information will depend on the type of information for example login information will be retained for up to 90 days from the date of collection.'
    },
    six: {
      title: '6.How do exercise the rights to data?',
      text1: 'You have special rights regarding your information and the way we use your information. These rights include the way you access the data the way you erase it the way you restrict the use of your data refuse to use the data and obtain a copy of your information.'
    },
    seven: {
      title: '7.Dispute Resolution',
      text1: 'Please contact us if you have any concerns or complaints:',
      text2: 'Hong Kong:  +852  2156 6888',
      text3: 'China: 400  888 4333'
    },
    eight: {
      title: '8.How do we notify you of changes?',
      text1: ' If there are any major changes to this privacy policy, we will send you a notification before the changes take effect. ',
      text2: 'We value your privacy. The purpose of this privacy policy is to inform you about the choices you can make and our practices regarding any information you provide to us or information generated by your use of eSender. Use of our services includes the processing of your information. You need to understand the process of collecting and using your information and how you can manage it. ',
      text3: 'These are all important information. Please read this privacy policy carefully. '
    },
    nice: {
      title: '9.Contact us',
      text1: 'Please contact our customer service if you have any inquiries about this privacy policy:',
      text2: 'Hong Kong:  +852  2156 6888',
      text3: 'China: 400  888 4333'
    },
    update: {
      text1: 'Guangzhou Multibyte Info Service Limited. -Last revised by'
    }
  },
  regulation: {
    title: 'Terms and Conditions',
    clause: {
      clauseTitle1: '“eSender”Service Agreement (Hong Kong Number)',
      clause1: ' 1、The above service provides receiving and sending SMS through the eSender Official Account. SIM card, MNP, voice and data services are also applicable. SIM card delivery fee will be charged. Voice and data services are applicable for the accounts using the package and fees will be charged for sending SMS.',
      clause2: ' 2、Sending SMS is only applicable for the accounts using the package and fees will be charged for sending SMS. For details, please visit the website of Multibyte Info Technology Limited“Multibyte”, www.multi-byte.com. ',
      clause3: ' 3、Before the expiry date, SMS alert will be sent SMS to the Hong Kong Number of the registered eSender service. Customer can check the message at the eSender Official Account. Customer can recharge and extend the expiry date via WeChat or Multibyte’s web site, www.multi-byte.com.',
      clause4: ' 4、The service will be suspended on the expiry date. Customer can reactivate the service by recharge on the WeChat or Company web site of Multi-byte.',
      clause5: ' 5、If the service is suspended over 7 days due to any reason, the eSender Hong Kong Number will be given to Multibyte.',
      clause6: ' 6、The eSender Hong Kong Number can be changed.',
      clause7: ' 7、Refund is not applicable for the suspension fur to all reasons.',
      clause8: ' 8、All offers are non-transferrable, non-refundable and cannot be redeemed to other service or products.',
      clause9: ' 9、This Statement is made by Multibyte Info Technology Limited (“Our Company”) in accordance with the General Terms and Conditions. For details, please visit Multibyte’s web site, www.multi-byte.com.',
      clause10: ' 10、The provision of personal data is voluntary. If you do not provide sufficient information, you may not be able to apply the eSender service. Multibyte may use your personal data mentioned above for marketing the goods and/or services. Enabling Multibyte to use and retain the personal data provided by you to perform any obligations on interconnection or conform with other industry practices, or to comply with any requests stipulated by governmental or regulatory authorities',
      clause11: ' 11、Multibyte Info Technology Limited reserves the right to amend the terms and conditions of this event registration. All matters and disputes in relation to the registration will be subject to the final decision of Multibyte Info Technology Limited.',
      clauseTitle2: '“eSender”Service Agreement (Hong Kong Number-Mobile Number Portability“MNP”)',
      clause12: ' 12、The above service provides receiving and sending SMS through the eSender Official Account. SIM card, MNP, voice and data services are also applicable. SIM card delivery fee will be charged. Voice and data services are applicable for the accounts using the package and fees will be charged for sending SMS.',
      clause13: ' 13、Sending SMS is only applicable for the accounts using the package and fees will be charged for sending SMS. For details, please visit the website of Multibyte Info Technology Limited“Multibyte”, www.multi-byte.com. ',
      clause14: ' 14、Before the expiry date, SMS alert will be sent SMS to the Hong Kong Number of the registered eSender service. Customer can check the message at the eSender Official Account. Customer can recharge and extend the expiry date via WeChat or Multibyte’s web site, www.multi-byte.com.',
      clause15: ' 15、The service will be suspended on the expiry date. Customer can reactivate the service by recharge on the WeChat or Company web site of Multi-byte.',
      clause16: ' 16、If the service is suspended over 7 days due to any reason, the eSender Hong Kong Number will be given to Multibyte.',
      clause17: ' 17、The eSender Hong Kong Number can be changed.',
      clause18: ' 18、Refund is not applicable for the suspension fur to all reasons.',
      clause19: ' 19、All offers are non-transferrable, non-refundable and cannot be redeemed to other service or products.',
      clause20: ' 20、I understand that the porting of the Mobile Number does not affect our/my obligations owing to the DNO incurred prior to the successful porting of the Mobile Number under the applicable service terms and conditions of the DNO.',
      clause22: ' 21、The Requested Cut-over Time is subject to the DNO’s confirmation of the details herein and the technical arrangements between the DNO and Multibyte in accordance with the Code of Practice related to the Implementation of Mobile Number Portability issued by the Communications Authority. Multibyte is hereby expressly authorized to change the Requested Cut-over Time as Multibyte may reasonably consider appropriate.',
      clause23: ' 22、In the event that the Mobile Number cannot be ported to Multibyte’s network due to the incomplete‚ wrong or false information provided by us/me or any grounds beyond the reasonable control of Multibyte‚ Multibyte has the right to cancel this porting application.',
      clause24: ' 23、Except for any liability which cannot be excluded by law‚ I agree that the DNO and Multibyte will not be liable to me or any other party in contract‚ tort or otherwise for any loss or damage suffered by me or any other party howsoever arising from or in relation to this application and the related number porting arrangements ',
      clause25: ' 24、This Statement is made by Multibyte Info Technology Limited (“Our Company”) in accordance with the General Terms and Conditions. For details, please visit Multibyte’s web site, www.multi-byte.com.',
      clause26: ' 25、The provision of personal data is voluntary. If you do not provide sufficient information, you may not be able to apply the eSender service. Multibyte may use your personal data mentioned above for marketing the goods and/or services. Enabling Multibyte to use and retain the personal data provided by you to perform any obligations on interconnection or conform with other industry practices, or to comply with any requests stipulated by governmental or regulatory authorities',
      clause27: ' 26、Multibyte Info Technology Limited reserves the right to amend the terms and conditions of this event registration. All matters and disputes in relation to the registration will be subject to the final decision of Multibyte Info Technology Limited.',
      clauseTitle3: '“eSender”Service Agreement (China Number)',
      clause28: ' 27、No SIM card will be provided for the eSender Service.',
      clause29: ' 28、The above service only provides receiving and sending SMS through the eSender Official Account. Voice and data services are not applicable. Sending SMS is only applicable for the accounts using the package and fees will be charged for sending SMS. For details, please visit the website of Multibyte Info Technology Limited www.multi-byte.com.',
      clause30: ' 29、Before the expiry date, SMS alert will be sent SMS to the China Number of the registered eSender service. Customer can check the message at the eSender Official Account. Customer can recharge and extend the expiry date via WeChat or Multibyte’s web site, www.multi-byte.com.',
      clause31: ' 30、The service will be suspended on the expiry date. Customer can reactivate the service by recharge on the WeChat or Company web site of Multi-byte.',
      clause32: ' 31、If the service is suspended over 30days due to any reason, the eSender China Number will be given to Multibyte.',
      clause33: ' 32、The eSender China Number can be changed.',
      clause34: ' 33、The China Number can only be applicable for the eSender Service.',
      clause35: ' 34、Refund is not applicable for the suspension fur to all reasons.',
      clause36: ' 35、All offers are non-transferrable, non-refundable and cannot be redeemed to other service or products.',
      clause37: ' 36、In light of the mobile number real name registration of the Mainland Chinese Government, it is necessary for us to collect your personal data including your name, mobile numbers, contact information, the information of your Mainland Travel Permit for Hong Kong and Macao Residents, China Resident Identity Card, Foreign Residents’ passport or other identity documents, bareheaded photo and selfie vedio(“the said personal data”) in order to assist you to comply with the said mobile number real name registration (“the Registration”). The said personal data may be changed according to the mobile number real name registration of the Mainland Chinese Government. You are not obliged to provide the said personal data to us. However, if you do not, the Mainland Chinese Government will have your Chinese mobile number suspended, and you may not be able to activate, use, or continue to use, the telecommunication services with the Mainland China mobile number. For details, please visit Multibyte’s web site www.multi-byte.com.',
      clause38: ' 37、In case of any false trading or other trading activity in which the account is treated as a commodity, Multibyte reserves the right to permanently terminate the service without any compensation or prior notice.',
      clause39: ' 38、Users should not use eSender services for any illegal action, such as telephone deception, internet fraud, spam SMS, Multibyte reserves the right to permanently terminate the service without any compensation or prior notice.',
      clause40: ' 39、This Statement is made by Multibyte Info Technology Limited (“Our Company”) in accordance with the General Terms and Conditions. For details, please visit Multibyte’s web site, www.multi-byte.com.',
      clause41: ' 40、The provision of personal data is voluntary. If you do not provide sufficient information, you may not be able to apply the eSender service. Multibyte may use your personal data mentioned above for marketing the goods and/or services. Enabling Multibyte to use and retain the personal data provided by you to perform any obligations on interconnection or conform with other industry practices, or to comply with any requests stipulated by governmental or regulatory authorities',
      clause42: ' 41、Multibyte Info Technology Limited reserves the right to amend the terms and conditions of this event registration. All matters and disputes in relation to the registration will be subject to the final decision of Multibyte Info Technology Limited.',
      clauseEnd: ' I have read and understood the terms/conditions of this agreement, and I agree with the above Terms and Conditions.'
    }
  },
  charge: {
    title: 'Тариф за продукцию',
    select: {
      option1: 'Все блюда.',
      option2: 'Китайский набор номеров гонконга',
      option3: 'Китайский набор номеров гонконга'
    },
    price: 'стоимость',
    dayNum: 'харикл',
    receiveMsg: 'Получить сообщение',
    data: 'Подвижные данные',
    limitless: 'бесконечн',
    service: 'обслуживание',
    phoneTime: 'Минута разговора.',
    phoneTimeAndData: 'Минута разговора.、Подвижные данные',
    notAvailable: 'Не применимо',
    day: 'небо',
    minute: 'минут',
    hk: '(Гонконг)',
    mo: '(Аомэнь)',
    cn_mo: '(Китай и макао)',
    hkTableTitle: 'Гонконгский набор номеров',
    package: {
      p1: 'сообщение для микрописем (пакет бесплатных SIM-карт)',
      p2: 'пакет SIM-карт/eSIM',
      p3: 'пакет сейм ',
      p4: 'пакет SIM'
    },
    tips: {
      t1: '(Только для гонконга)',
      t2: '( Применимо к гонконгу в китае)',
      t3: '(Только в Гонконге и Макао.)',
      t4: '( Только для гонконга и макао)',
      t5: '( Применимо к гонконгу и макао в китае)',
      t6: '( Относится к внутренним землям китая, гонконгу, макао, тайваню)',
      t7: '( Распространяется на внутренние районы китая, Гонконг, макао, Тайвань, США, канаду, корею, японию, сингапур, малайзию и Таиланд )',
      t8: '( Распространяется на Китай и Гонконг)',
      t9: '(Распространяется на Китай и Гонконг)',
      t10: '(Это относится ко многим регионам)'
    }
  },
  provisionNumber: {
    info: {
      head: 'Registration',
      title: 'Registration',
      tips: 'Each account can subscribe to 2 Hong Kong numbers and 1 China number.',
      no1: {
        title: 'Hong Kong number',
        info: '5 ways to Activate the Service'
      },
      no2: {
        title: 'China number',
        info: 'Free Trial for 7 Days During Promotion Period'
      },
      no3: {
        title: '國外手機號',
        info: '多款本地開通方式仼您選'
      }
    },
    infoHk: {
      head: 'Registration of Hong Kong number',
      headTips: 'The Telecommunications (Registration of SIM Cards) Regulation has taken effect to implement the Real-name Registration Programme for Subscriber Identification Module (SIM) Cards ("Real-name Registration Programme"). Protecting the security of telecommunications services, the new regulation has to prevent and assist the investigation of crimes involving the use of telephone prepaid SIM cards.',
      title: 'Registration of Hong Kong number',
      tips: 'Each account can subscribe to 2 Hong Kong numbers',
      no1: {
        title: 'General HK Number Registration',
        info: 'No SIM card service, App and WeChat receive text messages, Apps call out/in'
      },
      no2: {
        title: 'New HK Number Registration',
        info: 'New Number launch, limited supply',
        info2: 'No SIM card service, App and WeChat receive text messages, Apps call out/in'
      },
      no3: {
        title: 'Physical SIM',
        info: 'SIM card with voice and data services'
      },
      no4: {
        title: 'eSIM',
        info: 'Only support specific models of mobile devices'
      },
      no5: {
        title: 'MNP',
        info: 'Need to provide MNP information'
      }
    },
    infoCn: {
      head: 'Registration of China number',
      title: 'Registration of China number',
      tips: 'Each account can subscribe to 1 China numbers。',
      no1: {
        title: 'Mobile number',
        info: 'Free Trial for 7 Days, No SIM Card, Receive SMS via WeChat & App, Make & Receive Calls via App'
      },
      no2: {
        title: 'Special Number',
        info: 'Pair with specific plan'
      }
    },
    infoExt: {
      head: '訂購外國手機號',
      title: '訂購外國手機號',
      tips: '每個帳戶最多可以申請 X 個國外手機號。',
      areaTips: '請選擇地區...',
      area: {
        USA: 'USA',
        UK: 'UK',
        POL: 'POL'
      },
      no1: {
        title: 'UK mobile number',
        info: 'No SIM card, WeChat and App receive SMS'
      },
      no2: {
        title: 'USA mobile number',
        info: 'No SIM card, WeChat and App receive SMS'
      },
      no3: {
        title: 'POL mobile number',
        info: 'No SIM card, WeChat and App receive SMS'
      },
      no4: {
        title: '外國手機號',
        info: '英國 / 波蘭 號碼開通任您選'
      }
    }
  },
  payment: {
    head: 'выплата',
    title: 'выплата',
    phoneNo: 'нумерация',
    topUpNo: 'Зарядный номер',
    amount: 'сумма сделки',
    totalAmount: 'сумма',
    button: 'выплата',
    previous: 'вернут',
    paySuccess: 'Оплата прошла успешно.',
    confirm: 'определить',
    chargeBalance: 'сумма платежа',
    chargeType: 'Способ обмена.',
    tradeNo: 'Ссылка',
    payFail: 'Безуспешно платить',
    repay: 'Переплати.',
    canclePay: 'Переплати.',
    needHelp: 'Нужна помощь.?',
    confirmTips: 'Стоит ли отменять покупку и уезжать？',
    confirmSure: 'Продолжайте покупать.',
    confirmLeave: 'Из магазина.',
    selectPayType: 'Пожалуйста, выберите способ оплаты',
    money: {
      BALANCE: {
        title: 'Баланс ибботона',
        tips: ''
      },
      HKD: {
        title: 'Оплата в гонконгской валюте',
        tips: ''
      },
      CNY: {
        title: 'Юаней оплаты ваучеров',
        tips: 'Текущий курс обмена 100 юаней = 100 гонконгских долларов'
      },
      NTD: {
        title: 'Плата в тайваньской валюте',
        tips: 'Тайваньский гиперторговый код'
      },
      KRW: {
        title: 'Оплата в корейской валюте',
        tips: 'Текущий курс обмена — 160 вон = 1 гонконгская валюта'
      },
      RM: {
        title: 'Гиллингем.',
        tips: 'Текущий курс обмена 60 гиллинга = 100 гонконгских долларов'
      }
    },
    payType: {
      A: 'Alipay',
      B: 'Остаток платежа',
      W: 'Микровера.',
      AHK: 'Плати по гонконгу.',
      WHK: 'Микротаксисты платят гонконгу',
      U: 'Установк unionpay',
      P: 'Paypal',
      ABP: 'Aerobile Pay',
      L: 'LinePay',
      S: 'GooglePay',
      KK: 'KakaoPay',
      TN: 'Touch\'n Go',
      GB: 'GrabPay',
      BT: 'Boost',
      MAY: 'Maybank',
      APP: 'Apple Pay',
      ASPA: 'Apple Pay'
    }
  },
  balanceInfo: {
    head: 'Баланс переполнен',
    choosePhone: 'Выбери номер.',
    balance: 'вакансия',
    authPass: 'Настоящее имя подтверждено',
    authFail: 'Ненастоящее имя',
    auditing: 'Проверка подлинного удостоверения',
    auditing2: 'Его сейчас проверяют',
    unAuth: 'Подлинного имени нет',
    unAuthStatus: 'Не опознан по имени, недоступен',
    balanceRecharge: 'Баланс переполнен',
    tips1: 'Примечание: при наличии достаточного баланса данный номер не продлевается на срок службы, однако если у вас есть достаточный баланс, вы можете использовать его для продления срока действия или отправки сообщений в рамках программы закупок.',
    tips2: 'Примечание: если у вас достаточно балансов, этот номер не продлевает время службы, но если у вас достаточно балансов, вы можете использовать их в качестве продления или отправки информации в рамках программы покупки.',
    nextButton: 'следующий',
    noPhoneTips: 'В настоящее время у вас нет номера',
    status: 'состояние',
    normal: 'нормальн',
    expired: 'терпеть',
    active: 'вступить в силу',
    numExpired: 'Срок годност',
    notRealName: 'Ненастоящее имя.',
    noNumber: 'Нет номера.',
    endDate: 'Дата истечения срока',
    notApplicable: 'Не применимо'
  },
  payProcess: {
    tips1: 'оплата идет',
    tips2: 'сохраняйте спокойствие и не выключайте страницы, система работает с соответствующими покупками для вас.',
    btn: 'отмена'
  },
  question: {
    title: 'FAQ',
    title2: 'Feedback',
    line01: {
      title: 'How can the original wechat user use the new version of app?',
      content1: 'step1 : you need register a member from new Apps; step2: new account login in APP; step3: click "Me"-> Click the top personal portrait ->click "Login method bingding" ->choose "Binding with Wechat" "ON" step4: login again;',
      content2: ''
    },
    line02: {
      title: 'How many calling method for eSender APP? ',
      content1: '',
      content2: ''
    },
    line03: {
      title: 'What is the rule of sending and receiving SMS for eSender? ',
      content1: '',
      content2: ''
    },
    line04: {
      title: 'How to set permissions of eSender App? ',
      content1: 'Take Huawei brand mobile phones as an example, as shown below:',
      content2: ''
    },
    line05: {
      title: 'How to set the background process of eSender APP? ',
      content1: '',
      content2: ''
    },
    line06: {
      title: 'When there is an incoming call, I can only hear the ringtone, but fail to listen the call in eSender APP. How to set? ',
      content1: 'Open all available permissions in the mobile notification permission settings. Please refer to the mobile phone manual for specific settings.',
      content2: ''
    },
    line07: {
      title: 'How to review my product? ',
      content1: 'step1: click "me", step2: click "My Product"',
      content2: ''
    },
    line08: {
      title: 'When sending a SMS, “Incorrect receiver number” is shown. What should I do? ',
      content1: 'This could be caused by choosing the China number as receiver, or the receiving number is a China mobile number. For details, please refer to Point 3, rule of sending and receiving SMS for eSender',
      content2: ''
    },
    line09: {
      title: 'When making a call, there is a flash or no response, what should I do? ',
      content1: 'The possible reason is the dialed number is wrong, e.g. no area code was added. For details, please refer to Point 2, calling method of eSender APP.',
      content2: ''
    },
    line10: {
      title: 'Someone call my eSender number, but fail to connect. How to solve this problem? ',
      content1: 'This could be caused by the close of the eSender APP. It can be solved by open the eSender APP. If you want to keep online, please set the background process on your mobile. For details, please refer to Point 5, setting background process of eSender APP.',
      content2: ''
    },
    line11: {
      title: 'When the call is connected, I cannot hear caller’s voice or caller cannot hear my voice. What should I do? ',
      content1: '1）This could be caused by weak Wi-Fi / data connectivity. Please move to an area with better Wi-Fi / data coverage and remain there before you finish your call.',
      content2: '2）This could be caused by the settings of the security software of the mobile. Please check the settings and it is suggested to put eSender APP in the white list.；'
    },
    line12: {
      title: 'I need to login again after updating the new version. What should I do? ',
      content1: 'Please close the eSender APP, then login again',
      content2: ''
    },
    line13: {
      title: 'The is abnormal interface after login. What should I do? ',
      content1: 'Solution 1: Check the network settings or the mobile signal of the mobile.',
      content2: 'Solution 2: If Solution 1 cannot solve the problem, please follow the instruction to contact us.'
    },
    line14: {
      title: 'There is notification of the mobile for the SMS, but the SMS cannot be checked in the APP.',
      content1: 'This could be caused by the app conflict, please unstall the APP and install again.',
      content2: ''
    }
  },
  feedback: {
    head: 'Feedback',
    title: 'If there any problem when using eSender App, please send feedback to us. It would  help us to improve our services.',
    time: 'Time',
    year: 'Year',
    month: 'Month',
    day: 'Day',
    type: 'Problem type',
    selectType: 'Please choose the problem type',
    cancle: 'Cancel',
    sure: 'Confirm',
    view: 'Performance',
    selectView: 'Please choose proformance',
    net: 'Network',
    selectNet: 'Please choose network',
    region: 'Area',
    inputRegion: 'Please choose area',
    desc: 'Remarks',
    descTip: 'Not more than 200 characters',
    contactInfo: 'email',
    inputContactInfo: 'Please enter email',
    inputFailContactInfo: 'email is not correct',
    submit: 'Send',
    success: 'Your feedback has been submited',
    fail: 'Fail to submit',
    feedbackType: [{
      TYPE_ID: '1',
      TYPE_SORT: '1',
      TYPE_NAME: 'Network probelm'
    },
    {
      TYPE_ID: '2',
      TYPE_SORT: '2',
      TYPE_NAME: 'Authority problem'
    }
    ],
    networkInfo: [{
      NETWORK_ID: '1',
      TYPE_SORT: '1',
      NETWORK_NAME: 'WIFI'
    },
    {
      NETWORK_ID: '2',
      TYPE_SORT: '2',
      NETWORK_NAME: '3G'
    },
    {
      NETWORK_ID: '3',
      TYPE_SORT: '3',
      NETWORK_NAME: '4G'
    }
    ],
    feedbackDetail: [{
      TYPE_ID: '1',
      DETAIL_ID: '1',
      TYPE_SORT: '1',
      DETAIL_NAME: 'Not smooth'
    },
    {
      TYPE_ID: '1',
      DETAIL_ID: '2',
      TYPE_SORT: '2',
      DETAIL_NAME: 'Poor quality of the voice'
    },
    {
      TYPE_ID: '2',
      DETAIL_ID: '3',
      TYPE_SORT: '3',
      DETAIL_NAME: 'Probelm'
    },
    {
      TYPE_ID: '2',
      DETAIL_ID: '4',
      TYPE_SORT: '4',
      DETAIL_NAME: 'Bad experience'
    }
    ]
  },
  realNameVerify: {
    head: 'Real Name Registration',
    idType: 'Identity type',
    hkId: 'Hong Kong ID card',
    cnId: 'China ID card',
    upLoadFacePic: 'Upload the photo of the front of identity document',
    upLoadBackPic: 'Upload the photo of the back side of identity document.',
    upLoadTips: 'Please use the original identity document for the registration to avoid reflection.',
    scan: 'Scan',
    notice: 'Please enter the information as same as those on the identity document.',
    idInputTitle: 'Identity document number',
    enNameInputTitle: 'English FULL name',
    nameIputTitle: 'Chinese FULL name',
    finishBtn: 'Done',
    success: 'Registration success',
    fail: 'Registration fail',
    confirm: 'Confirm',
    successTips: 'You have completed the real name registration. It takes half to one hour for the verification. The result will be sent to the email given. Should you have any question, please feel free to contact us. Thanks!！',
    errorTips: {
      idNo: 'Please enter Identity document number',
      enName: 'Please enter English FULL name',
      name: 'Please enter Chinese FULL name',
      idFrontPic: 'Please upload the photo of the front of identity document',
      idBackPic: 'Please upload the photo of the front of identity document'
    }
  },
  business: {
    provision: {
      title: 'Registration of Hong Kong number',
      registerErr: 'Fail to register Hong Kong Number',
      registerOk: 'Successfully Register Hong Kong Number',
      plan: {
        title: 'No SIM card',
        content: 'No SIM card, App receives SMS, App answers calls. Mobile numbers purchased on the app cannot receive SMS on WeChat.',
        selectTip: 'Please select the package...',
        tip: 'Please select the package',
        warn: 'Fail to choose package'
      },
      number: {
        title: 'Please choose your favorite number',
        content: 'Other choices',
        selectTip: '(Can choose once only)',
        tip: 'Please choose number',
        warn: 'Fail to choose number',
        tipTitle: 'Restrict purchase',
        tipContent: 'Your application has reached the upper limit. Each account can register at least 1 eSender China number and 2 eSender Hong Kong numbers.'
      },
      member: {
        title: 'No SIM card',
        content: 'The Telecommunications Regulation has taken effect on 1 September 2021 to implement Real-name Registration Program of Hong Kong SIM cards. Protecting the security of telecommunications services, the new regulation has to prevent and assist the investigation of crimes involving the use of telephone prepaid SIM cards.',
        userlabel: 'User information',
        userTip: 'Input name',
        userWarn: 'Please input name',
        mobileTip: 'Input contact number',
        mobileWarn: 'Please input valid mobile number',
        codeLabel: 'Promotion code',
        codeTip: 'Promotion code(if any)',
        codeWarn: 'Please enter valid promotion code',
        codeOk1: 'Promotion offer is applied',
        codeOk2: ' valid day',
        useCodeTip: 'The discount code is invalid. Continue to purchase?',
        useBut: 'continue',
        cancleUseBut: 'cancel',
        mobilePrefixTitle: 'Select the phone area code',
        mobilePrefixList: [
          {name: 'Hong Kong SAR (China)（+852）', value: '852'},
          {name: 'China（+86）', value: '86'},
          {name: 'Macau(China)（+853）', value: '853'},
          {name: 'Taiwan (China)（+886）', value: '886'},
          {name: 'United States / Canada（+1）', value: '1'},
          {name: 'UK（+44）', value: '44'},
          {name: 'Malaysia（+60）', value: '60'},
          {name: 'Australia（+61）', value: '61'},
          {name: 'Philippines（+63）', value: '63'},
          {name: 'Indonesia（+62）', value: '62'},
          {name: 'Singapore（+65）', value: '65'},
          {name: 'Thailand（+66）', value: '66'},
          {name: 'Japan（+81）', value: '81'},
          {name: 'South Korea（+82）', value: '82'},
          {name: 'Vietnam（+84）', value: '84'},
          {name: 'France（+33）', value: '33'},
          {name: 'Italy（+39）', value: '39'},
          {name: 'Germany（+49）', value: '49'},
          {name: 'Other', value: ''}
        ]
      },
      confirm: {
        title: 'Confirm Order',
        tetle2: 'No SIM card service',
        code: 'Promotion code',
        price: 'Total amount',
        plan: 'Package code',
        username: 'Input name',
        mobile: 'Contact number',
        add: 'add',
        day: 'valid day',
        update: 'Update'
      },
      letter: {
        title: '“eSender” Service Agreement (Hong Kong Number)',
        statement: 'DECLARATION',
        statementInfo: 'I have read and understand the Guangzhou Multibyte Info Technology Limited’s Privacy Policy and Personal Information Collection Statement, Point No.2 “Personal Information Collection Statement”. Please “√”the appropriate box in below.',
        statementDetail1: 'I agree with the above terms and conditions.',
        statementDetail4: 'I agree with Multibyte in Hong Kong to use my personal data for direct marketing services products.',
        statementDetail2: 'I agree with Multibyte in Hong Kong to use my personal data for direct marketing services products.',
        statementDetail3: 'I agree with Multibyte in Hong Kong to use my personal data, but only for Multibyte Hong Kong contract as well as by the direct provision of telecommunications services. (Including but not limited to, mobile voice and data services, international roaming/long distance telephone services, such as product promotions).',
        content: [
          'The above service provides receiving and sending SMS through eSender WeChat Official Account and/or eSender APP. Guangzhou Multibyte Info Technology Limited ( ”Multibyte” ) can also provide SIM card, MNP, voice and data services. SIM card delivery fee will be charged. Voice and data services are applicable for the accounts using the package and fees will be charged for sending SMS.',
          'Sending SMS is only applicable for the accounts using the package and fees will be charged for sending SMS. For details, please visit Multibyte’s website www.multi-byte.com.',
          'Before the expiry date, SMS alert will be sent SMS to the Hong Kong Number of the registered eSender service. Customer can check the message at the eSender Official Account and/or eSender APP. Customer can recharge and extend the expiry date via eSender Official Account, eSender APP or Multibyte’s web site, www.multi-byte.com.',
          'The service will be suspended on the expiry date. Customer can reactivate the service by recharge on the eSender Official Account, eSender APP or Multibyte’s web site.',
          'If the service is suspended over 3 days due to any reason, the eSender Hong Kong Number will be given to Multibyte.',
          'The eSender Hong Kong Number can be changed.',
          'Refund is not applicable for the suspension fur to all reasons.',
          'All offers are non-transferrable, non-refundable and cannot be redeemed to other service or products.',
          'The Telecommunications (Registration of SIM Cards) Regulation (the "Regulation") has taken effect to implement the Real-name Registration Programme for Subscriber Identification Module (SIM) Cards ("Real-name Registration Programme"). Protecting the security of telecommunications services, the new regulation has to prevent and assist the investigation of crimes involving the use of telephone prepaid SIM cards. According to this regulation, registered users are divided into personal and corporate users. Individual users are required to provide information as contained in their identification documents (Hong Kong Identity Card or other acceptable identification documents such as visitors travel documents) including name, date of birth, number of the identification document and its photo for registration. A company or corporate which would like to register as SIM card users are required to provide business registration information and specify a representative or a responsible person and provide the personal information of that person. A person below 16 years old who needs to register for SIM card services will require the endorsement of an adult. The telecommunications operator will also register the information of that adult.',
          'This Statement is made by Guangzhou Multibyte Info Technology Limited in accordance with the General Terms and Conditions. For details, please visit Multibyte’s web site, www.multi-byte.com.',
          'The provision of personal data is voluntary. If you do not provide sufficient information, you may not be able to apply the eSender service. Multibyte may use your personal data mentioned above for marketing the goods and/or services. Enabling Multibyte to use and retain the personal data provided by you to perform any obligations on interconnection or conform with other industry practices, or to comply with any requests stipulated by governmental or regulatory authorities.',
          'Guangzhou Multibyte Info Technology Limited reserves the right to amend the terms and conditions of this event registration. All matters and disputes in relation to the registration will be subject to the final decision of Multibyte Info Technology Limited.'
        ],
        warn: 'Please agree to the relevant terms.'
      },
      paySuccess: {
        hknum: 'Hong Kong Number'
      }
    }
  },
  tokenFail: {
    title: 'Warning',
    msg: 'Время посещения собрания истекло！',
    confirm: 'определить'
  },
  ordinaryNum: {
    head: 'Номер телефона в китае',
    title: 'Зарегистрированный номер мобильного телефона на материке',
    topTips: '«учитывая политику регистрации мобильных телефонов, проводимую китайским правительством на внутреннем уровне, все китайские пользователи должны иметь доступ, использовать или продолжать пользоваться китайскими внутренними номерами, если они зарегистрированы под настоящим именем.',
    title2: 'Подтвердите приказ.',
    topTips2: 'каждый может подать заявку только на Один номер мобильного телефона в китае, регистрация которого может быть доступна бесплатно в течение семи дней, например, если вы хотите сохранить этот номер после того, как он будет исчерпан, а платная платная платная платная плата будет продолжать использоваться.',
    custInfo: 'Информация о клиентах',
    idInfo: 'тип документов',
    inputTips: {
      idType: 'Выберите тип документов...',
      phone: 'Введите номер телефона.',
      idName: 'введите имя (идентичное имени удостоверения личности)',
      idNum: 'введите идентификационный номер',
      idFormat: 'введите формат：AXXXXXXX',
      phoneNeed11: 'введите 11 - битный номер телефона',
      phoneNeed8: 'введите 8 - битный номер телефона',
      needHKId: 'введите действительное гонконгское удостоверение личности',
      needCNId: 'пожалуйста, введите действительный код внутреннего китая'
    },
    confirm: {
      idName: 'имя клиента',
      phone: 'Звоните',
      idType: 'тип документов',
      idNum: 'идентификационный номер'
    },
    idType: {
      CN: 'внутренние документы китая',
      CP: 'паспорт КНР',
      FC: 'удостоверение постоянного проживания иностранцев',
      HK: 'гонконгское удостоверение личности',
      HM: 'пропуска для жителей порта и австралии, входящих и выходящих из страны,',
      MC: 'удостоверение личности макао',
      PP: 'паспорт',
      RC: 'домашний вид на жительство',
      TW: 'картотека памяти'
    },
    btn: {
      back: 'Назад!',
      next: 'следующий',
      update: 'Модификация',
      goToCharge: 'Избыточная перезарядка',
      backIndex: 'вернуться на главную страницу'
    },
    success: 'Успешная заявка',
    fail: 'Регистрация не удалась',
    successTitle: 'внутренний номер китая',
    successTips: 'Поздравляю! Ваша честь успешно подала заявку на бесплатное проживание на китайском континенте! Мы предлагаем несколько комплектов для вашего заказа, с неограниченным временем получения сообщений. Если вы хотите сохранить этот номер после семи дней использования, то платные зарядки будут продолжать использоваться. Прежде чем начать пользоваться услугами, ваша честь должна пройти в weibboton eSender, чтобы зарегистрировать настоящий номер. Пожалуйста, ваше превосходительство, приготовьте документы на регистрационный номер и фотографии личности.',
    letter: {
      title: '“eSender” Service Agreement (Hong Kong Number)',
      statement: 'DECLARATION',
      statementInfo: 'I have read and understand the Guangzhou Multibyte Info Technology Limited’s Privacy Policy and Personal Information Collection Statement, Point No.2 “Personal Information Collection Statement”. Please “√”the appropriate box in below.',
      statementDetail1: 'I agree with the above terms and conditions.',
      statementDetail4: 'I agree with Multibyte in Hong Kong to use my personal data for direct marketing services products.',
      statementDetail2: 'I agree with Multibyte in Hong Kong to use my personal data for direct marketing services products.',
      statementDetail3: 'I agree with Multibyte in Hong Kong to use my personal data, but only for Multibyte Hong Kong contract as well as by the direct provision of telecommunications services. (Including but not limited to, mobile voice and data services, international roaming/long distance telephone services, such as product promotions).',
      content: [
        'The above service provides receiving and sending SMS through eSender WeChat Official Account and/or eSender APP. Guangzhou Multibyte Info Technology Limited ( ”Multibyte” ) can also provide SIM card, MNP, voice and data services. SIM card delivery fee will be charged. Voice and data services are applicable for the accounts using the package and fees will be charged for sending SMS.',
        'Sending SMS is only applicable for the accounts using the package and fees will be charged for sending SMS. For details, please visit Multibyte’s website www.multi-byte.com.',
        'Before the expiry date, SMS alert will be sent SMS to the Hong Kong Number of the registered eSender service. Customer can check the message at the eSender Official Account and/or eSender APP. Customer can recharge and extend the expiry date via eSender Official Account, eSender APP or Multibyte’s web site, www.multi-byte.com.',
        'The service will be suspended on the expiry date. Customer can reactivate the service by recharge on the eSender Official Account, eSender APP or Multibyte’s web site.',
        'If the service is suspended over 3 days due to any reason, the eSender Hong Kong Number will be given to Multibyte.',
        'The eSender Hong Kong Number can be changed.',
        'Refund is not applicable for the suspension fur to all reasons.',
        'All offers are non-transferrable, non-refundable and cannot be redeemed to other service or products.',
        'The Telecommunications (Registration of SIM Cards) Regulation (the "Regulation") has taken effect to implement the Real-name Registration Programme for Subscriber Identification Module (SIM) Cards ("Real-name Registration Programme"). Protecting the security of telecommunications services, the new regulation has to prevent and assist the investigation of crimes involving the use of telephone prepaid SIM cards. According to this regulation, registered users are divided into personal and corporate users. Individual users are required to provide information as contained in their identification documents (Hong Kong Identity Card or other acceptable identification documents such as visitors travel documents) including name, date of birth, number of the identification document and its photo for registration. A company or corporate which would like to register as SIM card users are required to provide business registration information and specify a representative or a responsible person and provide the personal information of that person. A person below 16 years old who needs to register for SIM card services will require the endorsement of an adult. The telecommunications operator will also register the information of that adult.',
        'This Statement is made by Guangzhou Multibyte Info Technology Limited in accordance with the General Terms and Conditions. For details, please visit Multibyte’s web site, www.multi-byte.com.',
        'The provision of personal data is voluntary. If you do not provide sufficient information, you may not be able to apply the eSender service. Multibyte may use your personal data mentioned above for marketing the goods and/or services. Enabling Multibyte to use and retain the personal data provided by you to perform any obligations on interconnection or conform with other industry practices, or to comply with any requests stipulated by governmental or regulatory authorities.',
        'Guangzhou Multibyte Info Technology Limited reserves the right to amend the terms and conditions of this event registration. All matters and disputes in relation to the registration will be subject to the final decision of Multibyte Info Technology Limited.'
      ],
      warn: 'Please agree to the relevant terms.'
    }
  },
  buyRecord: {
    head: 'Рекорд по продажам',
    number: 'Номер телефона',
    plan: 'План.',
    productType: 'тип продукции',
    orderTime: 'Время торговли',
    orderAmount: 'сумма транзакций',
    orderPayType: 'способ обмена',
    orderSn: 'справочный номер',
    noData: 'У вас нет приказа.'
  },
  addPackagePlan: {
    head: 'План заказа.',
    choosePlan: 'Пожалуйста, выберите пакет'
  },
  smartSIMHK: {
    head: '實體智能卡',
    subTitle: '包括：實體 SIM 卡、 4G 數據、通話分鐘、收取短訊',
    choosePlan: '請選擇你的計劃.....',
    planTips: '熱門優選套餐',
    expressTips: '選擇速遞地區及收費',
    shippingAddressTips: '輸入收貨地址',
    expressArea: {
      china: '中國內地',
      hk: '香港',
      taiwan: '台湾',
      macao: '澳門',
      malaysia: '馬來西亞',
      singapore: '新加坡'
    },
    expressWarn: '請選擇速遞地區及收費',
    addressWarn: '請輸入收貨地址',
    regTitle: '實體智能卡登記',
    regTips: '香港特區政府於2021年6月1日公布訂立《電訊（登記用戶識別卡）規例》，並於同年9月1日實施，以落實電話智能卡實名登記制度，保障健全的電訊服務及通訊網絡的安全，防止和協助偵查涉及使用電話儲值卡的罪案。',
    expressFee: '速遞費用',
    consigneeDistrict: '速遞地區',
    consigneeAddress: '收貨地址',
    successTips: '恭喜！閣下已經成功購買套餐。實體智能卡會於 7 天工作日內按排寄出。寄出後會已電郵通知您。 感謝閣下使用易博通服務！'
  },
  specialCnNumber: {
    head: '特選號碼',
    subTitle: '請輸入您的心儀號碼',
    fixedSection: '固定號碼段',
    favoriteNumber: '心儀號碼',
    find: '查找',
    notFindWarn: '找不到相關號碼，請重新輸入。',
    own: '可享',
    regTitle: '特選號碼登記',
    regTips: '鑒於中國內地政府推行的流動電話號碼實名登記政策，所有中國內地號碼用戶必須通過實名登記方能開通、使用或繼續使用中國內地號碼。每人只可以申請一個中國流動電話號碼， 成功登記後可付費充值開啟服務。',
    successTips1: '恭喜閣下已經成功申請易博通中國內地手機號， 如需要發出短信及通話，您可前往易博通微信公眾號付費充值，你的號碼亦可升級登記成為實體智能咭。 ',
    successTips2: '根據中國工信都相關條例，中國內地手機號必須實名認證後才可使用服務，請前往易博通微信公眾號進行登記。'
  },
  ukPlan: {
    title: 'UK mobile number registration',
    registerErr: 'Pre-registered UK number fail',
    registerOk: 'Pre-registered UK number success',
    plan: {
      title: 'UK mobile number',
      content: 'No SIM card, WeChat and App receive SMS',
      selectTip: 'Please select the package...',
      tip: 'Please select the package',
      warn: 'No packages are currently available for sale'
    },
    number: {
      title: 'Please choose your favorite number',
      content: 'Other choices',
      selectTip: '(Can choose once only)',
      tip: 'Please choose number',
      warn: 'Fail to choose number',
      tipTitle: 'Restrict purchase',
      tipContent: 'Your application limit has been reached. Every account can apply ONLY ONE UK mobile number.'
    },
    member: {
      title: 'UK mobile number',
      content: 'UK mobile number plan is a SIM-free plan. It is limited to use APP or WeChat receive SMS. (The plan does not include any calling, SMS and data service)',
      userlabel: 'User information',
      userTip: 'Input name',
      userWarn: 'Please input name',
      mobileTip: 'Input contact number',
      mobileWarn: 'Please input valid mobile number',
      codeLabel: 'Promotion code',
      codeTip: 'Promotion code(if any)',
      codeTip2: 'Input the promotion code can be add an additional 15 days after the number successful activated.',
      codeWarn: 'Please enter valid promotion code',
      codeOk1: 'Promotion offer is applied',
      codeOk2: ' valid day',
      useCodeTip: 'The discount code is invalid. Continue to purchase?',
      useBut: 'continue',
      cancleUseBut: 'cancel',
      mobilePrefixTitle: 'Select the phone area code',
      mobilePrefixList: [
        {name: 'Hong Kong SAR (China)（+852）', value: '852'},
        {name: 'China（+86）', value: '86'},
        {name: 'Macau(China)（+853）', value: '853'},
        {name: 'Taiwan (China)（+886）', value: '886'},
        {name: 'United States / Canada（+1）', value: '1'},
        {name: 'UK（+44）', value: '44'},
        {name: 'Malaysia（+60）', value: '60'},
        {name: 'Australia（+61）', value: '61'},
        {name: 'Philippines（+63）', value: '63'},
        {name: 'Indonesia（+62）', value: '62'},
        {name: 'Singapore（+65）', value: '65'},
        {name: 'Thailand（+66）', value: '66'},
        {name: 'Japan（+81）', value: '81'},
        {name: 'South Korea（+82）', value: '82'},
        {name: 'Vietnam（+84）', value: '84'},
        {name: 'France（+33）', value: '33'},
        {name: 'Italy（+39）', value: '39'},
        {name: 'Germany（+49）', value: '49'},
        {name: 'Other', value: ''}
      ]
    },
    confirm: {
      title: 'Confirm Order',
      tetle2: 'UK mobile number',
      code: 'Discount code',
      price: 'Total',
      plan: 'Plan',
      username: 'Enter name',
      mobile: 'Mobile number',
      add: 'Add',
      day: 'days vaild',
      update: 'Update'
    },
    letter: {
      title: '“eSender HK” Service Agreement (UK mobile number)',
      statement: 'DECLARATION',
      statementInfo: 'I have read and understood “Multi-byte” Privacy Policy and Personal Information Collection Statement - No.2 Personal Information Collection. Please tick in the appropriate box:',
      statementDetail1: 'I understand and accept the above Terms and Conditions. ',
      statementDetail4: 'I understand and accept that the “Multi-byte” will use of my personal data in Promotion or Direct Marketing. ',
      statementDetail2: 'I understand and accept that the “Multi-byte” will use of my personal data which limit to service continue arrangements and telecommunications services directly provided by “Multi-byte” (including but not limited to mobile voice, mobile data services, international roaming services/IDD service product promotion information). ',
      statementDetail3: 'I am not accept that the “Multi-byte” will use of my personal data in Promotion or Direct Marketing. ',
      content: [
        'The above service is provided in the WeChat “eSender HK" official account linking to UK mobile number SMS service.',
        '“Multi-byte” will send a message to the customer who has registered the UK mobile number as a reminder upon expiry of the service. Customers can check the usage within the validity period via WeChat Official Account "eSender HK" with the UK mobile number which has already linked up with WeChat. You may extend service validity by recharge it via WeChat Official Account at any time before its expiry.',
        'Upon the expiry of the service, it will be suspended without prior notice. Customers can make payment and reactivate the service on WeChat "eSender HK" official account. All SMS will not be reissued during the suspension period.',
        'Customer agrees that the assigned UK mobile number return to “Multi-byte” if the service is suspended more than 3 days or its terminated for any reason.',
        'The UK mobile numbers on service plans cannot be changed.',
        'The prepaid fee will not be refunded if the service is terminated for any reason.',
        'All offers are not transferable, cash refundable and/or non-exchangeable for other services and/or products.',
        'This service is subject to the 《General Terms and Conditions》of “Multi-byte”. Please visit the Multi-byte website (www.multi-byte.com) for the details.',
        '“Multi-byte” is not responsible for the accuracy of such information which voluntarily provided by you. We may not be able to provide or continue to provide our services to you if your personal data is incomplete or incorrect. “Multi-byte” has the right to use the above information to provide you with services, notify you of preferential promotions, and if necessary, disclosed to third parties for credit review, debt recovery, market research, and other purposes disclosed and used with your consent as required by law or in compliance with the requirements of recognized government agencies.',
        'Multibyte Info Technology Limited reserves the right to amend the terms and conditions of this event registration. All matters and disputes in relation to the registration will be subject to the final decision of Guangzhou Multibyte Info Technology Limited.'
      ],
      warn: 'Please agree to the relevant terms.'
    }
  },
  traveleSimPlan: {
    head: 'Subscribe eSIM',
    title: 'Subscribe eSIM',
    tips1: '1. eSIM package does not include voice and SMS service.',
    tips2: '2. Each account can subscribe maximum 5 eSIMs at the same time.',
    tips3: '3. HK$20 registration fee will be charged for each eSIM.',
    moreEsim: 'Details of eSIM >',
    chooseArea: 'Please choose country',
    registerErr: 'Fail to subscribe eSIM',
    registerOk: 'Successful subscribe of eSIM',
    areaWarn: 'Failed to access the area list',
    searchTips: 'Search Destination',
    hotTips: 'Hot Destination',
    areaTips: 'Areas',
    buy: 'Purchase',
    noData: 'No search result',
    noSearchArea: 'No related country / area',
    ApplicableTo: 'ApplicableTo',
    Details: 'Details',
    Description: 'Product Description',
    Instructions: 'Product Instructions',
    plan: {
      tips1: '1. eSIM package does not include voice and SMS service.',
      tips2: '2. Each account can subscribe maximum 5 eSIMs at the same time.',
      tips3: '3. HK$20 registration fee will be charged for each eSIM.',
      tips4: '4. FUP: When the monthly data usage reaches the plan entitlement, data service can continue with a maximum local data access speed with 128kbps.',
      tips5: '5. Unless otherwise specified with " * ", 4G network will be supported. For the area specified with " * ", 3G network will be provided.',
      selectTip: 'Please choose your package',
      tip: 'Please choose package',
      warn: 'Failed to get the available packages list'
    },
    member: {
      title: 'UK package without SIM card',
      content: 'On 1 June 2021, HKSAR gazetted the Telecommunications (Registration of SIM Cards) Regulation to implement the Real-name Registration Programme for Subscriber Identity Module (SIM) Cards with effecrive on 1 Sepemper 2021.  Protecting the security of telecommunications services, the new regulation has to prevent and assist the investigation of crimes involving the use of telephone prepaid SIM cards.',
      userlabel: 'Customer Information',
      emailTip: 'Input correct email',
      emailWarn: 'Please input correct email',
      reEmailTip: 'Please input correct email address',
      reEmailWarn: 'Please input correct email address',
      codeLabel: 'Promotion code',
      codeTip: 'Promotion code (if any)',
      codeWarn: 'Please input correct promotion code',
      codeOk1: 'Promotion code accepted. Extra validity for  ',
      codeOk2: ' effective days',
      useCodeTip: 'Promotion code is  invalid. Continue?',
      useBut: 'Continue',
      cancleUseBut: 'Cancel',
      mobileTypeTips: 'Choose Mobile model',
      mobileTypeWarn: 'Please choose mobile model'
    },
    confirm: {
      title: 'Confirm Order',
      code: 'Promotion code',
      price: 'Total amount',
      plan: 'Plan code',
      username: 'Input Name',
      mobile: 'Contact number',
      add: 'Add',
      day: 'Validity days',
      regPrice: 'eSIM registration fee',
      update: 'Amend',
      tips: 'Confirmation email of the eSIM will be sent to your email at about 5 minutes.',
      email: 'email address'
    },
    letter: {
      title: '“eSender HK” Service Agreement (eSIM)',
      statement: 'DECLARATION',
      statementInfo: 'I have read and understood “Multi-byte” Privacy Policy and Personal Information Collection Statement - No.2 Personal Information Collection. Please tick in the appropriate box:',
      statementDetail1: 'I understand and accept the above Terms and Conditions. ',
      statementDetail4: 'I understand and accept that the “Multi-byte” will use of my personal data in Promotion or Direct Marketing. ',
      statementDetail2: 'I understand and accept that the “Multi-byte” will use of my personal data which limit to service continue arrangements and telecommunications services directly provided by “Multi-byte” (including but not limited to mobile voice, mobile data services, international roaming services/IDD service product promotion information). ',
      statementDetail3: 'I am not accept that the “Multi-byte” will use of my personal data in Promotion or Direct Marketing. ',
      content: [
        'All eSender users, regardless holding a valid Hong Kong Number and/or a China Number or not, are entitled to subscribe Traveler eSIM.',
        'Unless specified, Traveler eSIM shall use 4G network.',
        'Each WeChat ID can subscribe maximum three Traveler eSIMs at the same time.',
        'The account of Traveler eSIM is totally independent with the eSender account of China Number and/or  Hong Kong Number, if any.',
        'Traveler eSIM supports Data service only, no service of Voice and SMS. No any Hong Kong Number or China Number is allocated to Traveler eSIM.',
        'The handset of the user must be equipped with eSIM. The handset must enable data roaming while using Traveler eSIM, which can surf all kinds of social network without any pre-registration. ',
        'The Traveler eSIM should be activated within 60 days upon the date of purchase.',
        'The Day is defined from 00:00:00~23:59:59, Beijing Time. The valid days are counted once the Traveler eSIM is activated. ',
        'Fair Usage Policy(FUP): Once the client consumes the high speed volume each day, the Data Speed will be lowered to 128kbps, and high speed will be resumed on the coming day.',
        'The Traveler eSIM can be top up by days at real time once it is activated, or within the 7 days after the Traveler eSIM is expired. If there is no any top up after 7 days when the Traveler eSIM is expired, the Traveler eSIM will be stopped sharply. ',
        'Data speed can vary due to factors such as relative position between you and the base station, server source, internet traffic conditions, number of users, device hardware, software and other factors that may arise.',
        'If there is no 4G coverage, 3G/2G/EDGE network may be used to provide data service. ',
        'Multibyte Info Technology Limited reserves the right to amend the terms and conditions of this service. All matters and disputes in relation to this service will be subject to the final decision of Multibyte Info Technology Limited.'
      ],
      warn: 'Please agree to the relevant terms.'
    }
  },
  myProduct: {
    head: 'Мой номер.',
    menu: {
      all: 'Все',
      hk: 'Гонконгский',
      cn: 'Китайский',
      eSim: 'ЭСИМ',
      ext: 'Зарубежные'
    },
    normal: 'Типичный',
    effective: 'Эффективный',
    invalid: 'Неверный',
    active: 'Занятый.',
    planExpired: 'Пакет просрочен.',
    expired: 'Отказ',
    expiredNoBalance: 'Отказ',
    toBeRecycle: 'Цифры будут восстановлены.',
    realName: 'Регистрация подлинного имени',
    notRealName: 'No RNR',
    addPlan: 'Купить пакет',
    balance: 'Равновесие',
    status: 'Статус',
    dueDate: 'Эффективность',
    deadline: 'Дата активации',
    update: 'Модернизировать',
    addPlanTips: 'Please buy package with *XX days  or otherwise, the eSender number will be cancelled and cannot be used again.',
    realNameTips: 'SMS cannot be sent if the real name registration is incomplete.',
    activation: 'Активировано',
    notActive: 'Не активирована',
    isDel: 'deleted',
    warn: 'Отсутствие доступа к продуктам',
    notApplicable: 'Не применимо',
    usedData: 'Используемые данные',
    typeInfo90: ['China number service', '1. eSender China number is non-SIM card package which allows user to send and receive SMS and call via eSender App or WeChat. (Data service is not applicable for the packages).', '2. Each WeChat account can apply one eSender China number and real name registration is needed.'],
    typeInfo91: ['Hong Kong number service', '1. eSender Hong Kong non-SIM card package which allows user to send and receive SMS and call via eSender App or WeChat. (Data service is not applicable for the packages).', '2. Real name registration is needed for the eSender Hong Kong number.'],
    typeInfo92: ['eSIM service', '1. voice and SMS service are not included in eSIM package.', '2. When monthly data usage reaches the package\'s data allowance, data service continues with data speed not less than 128kbps.'],
    typeInfo93: ['Taiwan number service', 'eSender Taiwan number is non-SIM card package which allows user to receive SMS via eSender App or WeChat. (Sending SMS, voice and data service is not applicable for the packages). '],
    typeInfo94: ['USA number service', 'eSender USA number is non-SIM card package which allows user to receive SMS via eSender App or WeChat. (Sending SMS, voice and data service is not applicable for the packages). '],
    typeInfo95: ['UK number service', 'eSender UK number is non-SIM card package which allows user to receive SMS via eSender App or WeChat. (Sending SMS, voice and data service is not applicable for the packages). '],
    typeInfo96: ['Malaysia number service', 'eSender Malaysia number is non-SIM card package which allows user to receive SMS via eSender App or WeChat. (Sending SMS, voice and data service is not applicable for the packages).']
  },
  eSimTopUp: {
    head: 'eSIM Recharge',
    choosESIM: 'Choose eSIM',
    choosPlan: 'Please Choose Plan',
    topUp: 'Recharge',
    update: 'Update',
    registerErr: 'eSIM Recharge Fail',
    getListWarn: 'List eSIM recharge plan fail',
    noData: 'No eSIM recharge data'
  },
  contactUs: {
    t1: 'Multi-Byte On WeChat',
    tips1: '1. Save the QR code and launch your WeChat app.',
    tips2: '2. Tap the “+” button in the top right-hand corner, and tap “Scan QR Code”. ',
    tips3: '3. Scan the QR code and view our official account right away.',
    btn: 'Save QR code'
  },
  gs: {
    rate: {
      title: ' Travel Call IDD Tariff',
      searchNoResult: 'no result',
      searchTip: 'search',
      tableTitleLeft: 'Country / Region',
      tableTitleCenter: 'Code',
      tableTitleRight: 'Charge',
      tableTitleRightUnit: '(HKD/min)',
      cancel: 'cancel',
      tipTitle: 'Remarks',
      tip1: '1. The following charges in calculated in Hong Kong dollars. The IDD charges will be calculated by minute basis.',
      tip2: '2. In addition to IDD rates,  China or Hong Kong/China call airtime charges is also applied.',
      tip3: '3. ADONKI LIMITED reserves the right to make the final decision on the following terms and conditions. Charges are subject to change without notice.'
    },
    company: {
      title: 'About ADONKI',
      ERCodeDesc: 'ADONKI',
      info: 'ADONKI LIMITED is a 24-hour online shopping platform and stores in  that specialize in internet card, data card and phone card stores around the world. It provides free surface mail, Hong Kong SF station and industrial and commercial address express delivery services. We provide free whatsapp technical support. , Our aim is to help you buy your favorite aquatic products at the best price.',
      gotoMB: 'Goto ADONKI'
    },
    privacyText: {
      title: 'Privacy Policy of  Travel Call ',
      summary:
        {
          title: 'Summary',
          text: 'ADONKI LIMITED. (" Travel Call " or "us" or "our" or other similar pronouns) take your privacy very seriously. Please read the following to learn more about our privacy policy ("Policy"). This policy details how we receive collect and use information about the services provided on the  Travel Call . (The above is collectively referred to as "services"). When using this service, it means that you accept the policies and practices described in this policy because this policy may be modified from time to time. Every time you use the service you agree and expressly agree that we collect use and disclose the information you provide in accordance with the provisions of this policy.'
        },
      one: {
        title: '1.\tWhat information will we collect from you?',
        text1: 'We will collect your data if you set up an  Travel Call account and use the services provided by us. We will collect your',
        text2: 'device model operating system location information mobile phone reading and writing microphone address book camera unique device identifier login IP address access to the network type and status network quality data operation Logs and nicknames are basic information that must be collected to provide services',
        text3: '，At the same time, you can provide more information to make your personal data more refined and popular. We will store the collected information properly and use it with caution。'
      },
      two: {
        title: '2. SDK directory of third-party vendors',
        substile1: '1) Jiguang SDK used for notification push',
        text2: 'A.Obtain permission:：',
        text3: '•Get your equipment information',
        text4: '•Get your read-write external storage',
        text5: '•Check your network connection status',
        text6: 'B.Purpose of use',
        text7: '•Notification push',
        text8: 'C.Processing method',
        text9: '•Use replacement, de-identification, encryption and anonymization to desensitize personal information',
        text10: 'D.Jiguang Privacy Agreement',
        subtitle2: '2)Umeng U-Share SDK',
        text20: 'In order to provide you with one-click sharing service our product integrates U-Share SDK. U-Share SDK needs to collect your device Mac address unique device identification code (IMEI/android ID/IDFA/OPENUDID/GUID, SIM card, IMSI information) and the social account public information you need to share in order to complete the one-click sharing service. And through the geographic location calibration report data accuracy provide basic anti-cheating services. For your information security we have entered into data security and confidentiality agreements with third-party SDK service providers and these companies will strictly abide by our data privacy and security requirements. Unless we have your consent, we will not share your personally identifiable information with them. In order for you to better understand the type and purpose of the data collected by [Umeng+] and how to protect your personal information.',
        text21: 'you can visit',
        text22: 'to understand the privacy policy of [Umeng+] .',
        subtitle3: '3) Tencent Bugly SDK',
        text30: 'In order to better troubleshoot crash issues and help improve the stability of the app, our product integrates the Tencent Bugly SDK. The Tencent Bugly SDK needs to collect information such as Android system version, vendor system version, and memory space usage. For your information security, we have entered into data security and confidentiality agreements with third-party SDK service providers, and these companies will strictly comply with our data privacy and security requirements. Unless we obtain your consent, we will not share your personally identifiable information with you. To facilitate your better understanding of the types and purposes of data collected by the Bugly SDK, as well as how to protect your personal information.',
        text31: 'You can visit ',
        text32: ' to understand the Bugly SDK Privacy Statement.'
      },
      three: {
        title: '3.How will we use your information?',
        text1: 'We will use your information to provide your  Travel Call service allow you to communicate with other users and use the functions of the  Travel Call public platform. We will use your information to set up accounts facilitate communication provide support allow you to access  Travel Call features and improve  Travel Call services. E-Sender will use the WeChat application you use to verify and protect your account. It will also be used for important management factors and  Travel Call will not use these communication channels for sales or marketing.'
      },
      four: {
        title: '4.Who will we share your information with?',
        text1: 'We will use third-party support services such as using the WeChat public platform to provide account verification services. When we use these third-party services to process or store your information, and it will be limited to the purposes set out in this policy. We will also share your information with Multi-byte related group companies and share it in accordance with legal requirements. Except for the purposes listed above  Travel Call will not share your information with third parties without your prior express consent. Any third-party service provider (selected by us) with which we share user information will provide the same or the same level of user information protection standards as described in this policy.'
      },
      five: {
        title: '5.How long will we keep your information? ',
        text1: 'The time we retain your information will depend on the type of information for example login information will be retained for up to 90 days from the date of collection.'
      },
      six: {
        title: '6.How do exercise the rights to data?',
        text1: 'You have special rights regarding your information and the way we use your information. These rights include the way you access the data the way you erase it the way you restrict the use of your data refuse to use the data and obtain a copy of your information.'
      },
      seven: {
        title: '7.Dispute Resolution',
        text1: 'Please contact us if you have any concerns or complaints:',
        text2: '',
        text3: 'E-mail: globalsimhk@gmail.com'
      },
      eight: {
        title: '8.How do we notify you of changes?',
        text1: ' If there are any major changes to this privacy policy, we will send you a notification before the changes take effect. ',
        text2: 'We value your privacy. The purpose of this privacy policy is to inform you about the choices you can make and our practices regarding any information you provide to us or information generated by your use of  Travel Call . Use of our services includes the processing of your information. You need to understand the process of collecting and using your information and how you can manage it. ',
        text3: 'These are all important information. Please read this privacy policy carefully. '
      },
      nice: {
        title: '9.Contact us',
        text1: 'Thank you for purchasing ADONKI LIMITED products. If you have any questions, need special technical assistance/product problems, please contact us directly through the following methods. We hope to hear from you and do our best to provide you with all solutions.',
        text2: '',
        text3: 'E-mail: globalsimhk@gmail.com'
      },
      update: {
        text1: 'ADONKI LIMITED. -Last revised by'
      }
    },
    regulation: {
      title: ' Travel Call Terms and Conditions',
      clause: {
        clauseTitle1: '“ Travel Call ”Service Agreement (Hong Kong Number)',
        clause1: ' 1、The above service provides receiving and sending SMS through the  Travel Call Official Account. SIM card, MNP, voice and data services are also applicable. SIM card delivery fee will be charged. Voice and data services are applicable for the accounts using the package and fees will be charged for sending SMS.',
        clause2: ' 2、Sending SMS is only applicable for the accounts using the package and fees will be charged for sending SMS. For details, please visit the website of ADONKI Limited“ADONKI”, adonkilimited.com. ',
        clause3: ' 3、Before the expiry date, SMS alert will be sent SMS to the Hong Kong Number of the registered  Travel Call service. Customer can check the message at the  Travel Call Official Account. Customer can recharge and extend the expiry date via WeChat or ADONKI’s web site, adonkilimited.com.',
        clause4: ' 4、The service will be suspended on the expiry date. Customer can reactivate the service by recharge on the WeChat or Company web site of Multi-byte.',
        clause5: ' 5、If the service is suspended over 7 days due to any reason, the  Travel Call Hong Kong Number will be given to ADONKI.',
        clause6: ' 6、The  Travel Call Hong Kong Number can be changed.',
        clause7: ' 7、Refund is not applicable for the suspension fur to all reasons.',
        clause8: ' 8、All offers are non-transferrable, non-refundable and cannot be redeemed to other service or products.',
        clause9: ' 9、This Statement is made by ADONKILimited (“Our Company”) in accordance with the General Terms and Conditions. For details, please visit ADONKI’s web site, adonkilimited.com.',
        clause10: ' 10、The provision of personal data is voluntary. If you do not provide sufficient information, you may not be able to apply the  Travel Call service. ADONKI may use your personal data mentioned above for marketing the goods and/or services. Enabling ADONKI to use and retain the personal data provided by you to perform any obligations on interconnection or conform with other industry practices, or to comply with any requests stipulated by governmental or regulatory authorities',
        clause11: ' 11、ADONKI LIMITED reserves the right to amend the terms and conditions of this event registration. All matters and disputes in relation to the registration will be subject to the final decision of ADONKI LIMITED.',
        clauseTitle2: '“ Travel Call ”Service Agreement (Hong Kong Number-Mobile Number Portability“MNP”)',
        clause12: ' 12、The above service provides receiving and sending SMS through the  Travel Call Official Account. SIM card, MNP, voice and data services are also applicable. SIM card delivery fee will be charged. Voice and data services are applicable for the accounts using the package and fees will be charged for sending SMS.',
        clause13: ' 13、Sending SMS is only applicable for the accounts using the package and fees will be charged for sending SMS. For details, please visit the website of ADONKI LIMITED“ADONKI”, adonkilimited.com. ',
        clause14: ' 14、Before the expiry date, SMS alert will be sent SMS to the Hong Kong Number of the registered  Travel Call service. Customer can check the message at the  Travel Call Official Account. Customer can recharge and extend the expiry date via WeChat or ADONKI’s web site, adonkilimited.com.',
        clause15: ' 15、The service will be suspended on the expiry date. Customer can reactivate the service by recharge on the WeChat or Company web site of Multi-byte.',
        clause16: ' 16、If the service is suspended over 7 days due to any reason, the  Travel Call Hong Kong Number will be given to ADONKI.',
        clause17: ' 17、The  Travel Call Hong Kong Number can be changed.',
        clause18: ' 18、Refund is not applicable for the suspension fur to all reasons.',
        clause19: ' 19、All offers are non-transferrable, non-refundable and cannot be redeemed to other service or products.',
        clause20: ' 20、I understand that the porting of the Mobile Number does not affect our/my obligations owing to the DNO incurred prior to the successful porting of the Mobile Number under the applicable service terms and conditions of the DNO.',
        clause22: ' 21、The Requested Cut-over Time is subject to the DNO’s confirmation of the details herein and the technical arrangements between the DNO and ADONKI in accordance with the Code of Practice related to the Implementation of Mobile Number Portability issued by the Communications Authority. ADONKI is hereby expressly authorized to change the Requested Cut-over Time as ADONKI may reasonably consider appropriate.',
        clause23: ' 22、In the event that the Mobile Number cannot be ported to ADONKI’s network due to the incomplete‚ wrong or false information provided by us/me or any grounds beyond the reasonable control of ADONKI‚ ADONKI has the right to cancel this porting application.',
        clause24: ' 23、Except for any liability which cannot be excluded by law‚ I agree that the DNO and ADONKI will not be liable to me or any other party in contract‚ tort or otherwise for any loss or damage suffered by me or any other party howsoever arising from or in relation to this application and the related number porting arrangements ',
        clause25: ' 24、This Statement is made by ADONKI LIMITED (“Our Company”) in accordance with the General Terms and Conditions. For details, please visit ADONKI’s web site, adonkilimited.com.',
        clause26: ' 25、The provision of personal data is voluntary. If you do not provide sufficient information, you may not be able to apply the  Travel Call service. ADONKI may use your personal data mentioned above for marketing the goods and/or services. Enabling ADONKI to use and retain the personal data provided by you to perform any obligations on interconnection or conform with other industry practices, or to comply with any requests stipulated by governmental or regulatory authorities',
        clause27: ' 26、ADONKI LIMITED reserves the right to amend the terms and conditions of this event registration. All matters and disputes in relation to the registration will be subject to the final decision of ADONKI LIMITED.',
        clauseTitle3: '“ Travel Call ”Service Agreement (China Number)',
        clause28: ' 27、No SIM card will be provided for the  Travel Call Service.',
        clause29: ' 28、The above service only provides receiving and sending SMS through the  Travel Call Official Account. Voice and data services are not applicable. Sending SMS is only applicable for the accounts using the package and fees will be charged for sending SMS. For details, please visit the website of ADONKI LIMITED adonkilimited.com.',
        clause30: ' 29、Before the expiry date, SMS alert will be sent SMS to the China Number of the registered  Travel Call service. Customer can check the message at the  Travel Call Official Account. Customer can recharge and extend the expiry date via WeChat or ADONKI’s web site, adonkilimited.com.',
        clause31: ' 30、The service will be suspended on the expiry date. Customer can reactivate the service by recharge on the WeChat or Company web site of Multi-byte.',
        clause32: ' 31、If the service is suspended over 30days due to any reason, the  Travel Call China Number will be given to ADONKI.',
        clause33: ' 32、The  Travel Call China Number can be changed.',
        clause34: ' 33、The China Number can only be applicable for the  Travel Call Service.',
        clause35: ' 34、Refund is not applicable for the suspension fur to all reasons.',
        clause36: ' 35、All offers are non-transferrable, non-refundable and cannot be redeemed to other service or products.',
        clause37: ' 36、In light of the mobile number real name registration of the Mainland Chinese Government, it is necessary for us to collect your personal data including your name, mobile numbers, contact information, the information of your Mainland Travel Permit for Hong Kong and Macao Residents, China Resident Identity Card, Foreign Residents’ passport or other identity documents, bareheaded photo and selfie vedio(“the said personal data”) in order to assist you to comply with the said mobile number real name registration (“the Registration”). The said personal data may be changed according to the mobile number real name registration of the Mainland Chinese Government. You are not obliged to provide the said personal data to us. However, if you do not, the Mainland Chinese Government will have your Chinese mobile number suspended, and you may not be able to activate, use, or continue to use, the telecommunication services with the Mainland China mobile number. For details, please visit ADONKI’s web site adonkilimited.com.',
        clause38: ' 37、In case of any false trading or other trading activity in which the account is treated as a commodity, ADONKI reserves the right to permanently terminate the service without any compensation or prior notice.',
        clause39: ' 38、Users should not use  Travel Call services for any illegal action, such as telephone deception, internet fraud, spam SMS, ADONKI reserves the right to permanently terminate the service without any compensation or prior notice.',
        clause40: ' 39、This Statement is made by ADONKI LIMITED (“Our Company”) in accordance with the General Terms and Conditions. For details, please visit ADONKI’s web site, adonkilimited.com.',
        clause41: ' 40、The provision of personal data is voluntary. If you do not provide sufficient information, you may not be able to apply the  Travel Call service. ADONKI may use your personal data mentioned above for marketing the goods and/or services. Enabling ADONKI to use and retain the personal data provided by you to perform any obligations on interconnection or conform with other industry practices, or to comply with any requests stipulated by governmental or regulatory authorities',
        clause42: ' 41、ADONKI LIMITED reserves the right to amend the terms and conditions of this event registration. All matters and disputes in relation to the registration will be subject to the final decision of ADONKI LIMITED.',
        clauseEnd: ' I have read and understood the terms/conditions of this agreement, and I agree with the above Terms and Conditions.'
      }
    },
    charge: {
      title: ' Travel Call Price List',
      select: {
        option1: 'ALL Package',
        option2: 'Hong Kong Number Package',
        option3: 'China Number Package'
      },
      price: 'Price',
      dayNum: 'Days',
      receiveMsg: 'Receive SMS',
      data: 'Mobile Data',
      limitless: 'Unlimited',
      service: 'Service',
      phoneTime: 'Airtime',
      phoneTimeAndData: 'Airtime、Mobile Data',
      notAvailable: 'N/A',
      day: 'Days',
      minute: 'Minutes',
      hk: '(Hong Kong)',
      mo: '(Macau)',
      cn_mo: '(China & Macau)',
      hkTableTitle: 'Hong Kong Number Package',
      package: {
        p1: 'Wechat receive （Free SIM Card Package）',
        p2: 'SIM Card',
        p3: 'eSIM',
        p4: 'SIM Card'
      },
      tips: {
        t1: '(Applicable in Hong Kong)',
        t2: '( Applicable in Hong Kong )',
        t3: '(Applicable in Hong Kong and Macau)',
        t4: '( Applicable in Hong Kong and Macau )',
        t5: '( Applicable in Hong Kong and Macau )',
        t6: '( Applicable in China, Hong Kong,  Macau and Taiwan)',
        t7: '( Applicable in China, Hong Kong, Macau ,Taiwan,USA,Canada,Japan,Korea,Singapore,Malaysia and Thailand )',
        t8: '( Applicable in China and  Hong Kong )',
        t9: '(Applicable in Hong Kong)',
        t10: '(Applicable in multiple regions)'
      }
    },
    question: {
      title: ' Travel Call FAQ',
      title2: 'Feedback',
      line01: {
        title: 'How can the original wechat user use the new version of app?',
        content1: 'step1 : you need register a member from new Apps; step2: new account login in APP; step3: click "Me"-> Click the top personal portrait ->click "Login method bingding" ->choose "Binding with Wechat" "ON" step4: login again;',
        content2: ''
      },
      line02: {
        title: 'How many calling method for  Travel Call APP? (For : iOS/Android)',
        content1: '',
        content2: ''
      },
      line03: {
        title: 'What is the rule of sending and receiving SMS for  Travel Call ? (For : iOS/Android)',
        content1: '',
        content2: ''
      },
      line04: {
        title: 'How to set permissions of  Travel Call App? (For : Android)',
        content1: 'Take Huawei brand mobile phones as an example, as shown below:',
        content2: ''
      },
      line05: {
        title: 'How to set the background process of  Travel Call APP? (For: Android)',
        content1: '',
        content2: ''
      },
      line06: {
        title: 'When there is an incoming call, I can only hear the ringtone, but fail to listen the call in  Travel Call APP. How to set? (For : Android)',
        content1: 'Open all available permissions in the mobile notification permission settings. Please refer to the mobile phone manual for specific settings.',
        content2: ''
      },
      line07: {
        title: 'How to review my product? (For : iOS/Android)',
        content1: 'step1: click "me", step2: click "My Product"',
        content2: ''
      },
      line08: {
        title: 'When sending a SMS, “Incorrect receiver number” is shown. What should I do? (For : iOS/Android)',
        content1: 'This could be caused by choosing the China number as receiver, or the receiving number is a China mobile number. For details, please refer to Point 3, rule of sending and receiving SMS for  Travel Call ',
        content2: ''
      },
      line09: {
        title: 'When making a call, there is a flash or no response, what should I do? (For : iOS/Android)',
        content1: 'The possible reason is the dialed number is wrong, e.g. no area code was added. For details, please refer to Point 2, calling method of  Travel Call APP.',
        content2: ''
      },
      line10: {
        title: 'Someone call my  Travel Call number, but fail to connect. How to solve this problem? (For : iOS/Android)',
        content1: 'This could be caused by the close of the  Travel Call APP. It can be solved by open the  Travel Call APP. If you want to keep online, please set the background process on your mobile. For details, please refer to Point 5, setting background process of  Travel Call APP.',
        content2: ''
      },
      line11: {
        title: 'When the call is connected, I cannot hear caller’s voice or caller cannot hear my voice. What should I do? (For : iOS/Android)',
        content1: '1）This could be caused by weak Wi-Fi / data connectivity. Please move to an area with better Wi-Fi / data coverage and remain there before you finish your call.',
        content2: '2）This could be caused by the settings of the security software of the mobile. Please check the settings and it is suggested to put  Travel Call APP in the white list.；'
      },
      line12: {
        title: 'I need to login again after updating the new version. What should I do? (For : Android)',
        content1: 'Please close the  Travel Call APP, then login again',
        content2: ''
      },
      line13: {
        title: 'The is abnormal interface after login. What should I do? (For : iOS/Android)',
        content1: 'Solution 1: Check the network settings or the mobile signal of the mobile.',
        content2: 'Solution 2: If Solution 1 cannot solve the problem, please follow the instruction to contact us.'
      },
      line14: {
        title: 'There is notification of the mobile for the SMS, but the SMS cannot be checked in the APP.(For: Android)',
        content1: 'This could be caused by the app conflict, please unstall the APP and install again.',
        content2: ''
      }
    },
    feedback: {
      head: 'Feedback',
      title: 'If there any problem when using  Travel Call App, please send feedback to us. It would  help us to improve our services.',
      time: 'Time',
      year: 'Year',
      month: 'Month',
      day: 'Day',
      type: 'Problem type',
      selectType: 'Please choose the problem type',
      cancle: 'Cancel',
      sure: 'Confirm',
      view: 'Performance',
      selectView: 'Please choose proformance',
      net: 'Network',
      selectNet: 'Please choose network',
      region: 'Area',
      inputRegion: 'Please choose area',
      desc: 'Remarks',
      descTip: 'Not more than 200 characters',
      contactInfo: 'email',
      inputContactInfo: 'Please enter email',
      inputFailContactInfo: 'email is not correct',
      submit: 'Send',
      success: 'Your message have been sent!',
      successTips1: 'For faster service, please contact us through WhatsApp at +852 6398 7656',
      successTips2: 'From Monday to Sunday, 12:00-21:00',
      successBtn: 'I Know',
      fail: 'Fail to submit',
      feedbackType: [{
        TYPE_ID: '1',
        TYPE_SORT: '1',
        TYPE_NAME: 'Network probelm'
      },
      {
        TYPE_ID: '2',
        TYPE_SORT: '2',
        TYPE_NAME: 'Authority problem'
      }
      ],
      networkInfo: [{
        NETWORK_ID: '1',
        TYPE_SORT: '1',
        NETWORK_NAME: 'WIFI'
      },
      {
        NETWORK_ID: '2',
        TYPE_SORT: '2',
        NETWORK_NAME: '3G'
      },
      {
        NETWORK_ID: '3',
        TYPE_SORT: '3',
        NETWORK_NAME: '4G'
      }
      ],
      feedbackDetail: [{
        TYPE_ID: '1',
        DETAIL_ID: '1',
        TYPE_SORT: '1',
        DETAIL_NAME: 'Not smooth'
      },
      {
        TYPE_ID: '1',
        DETAIL_ID: '2',
        TYPE_SORT: '2',
        DETAIL_NAME: 'Poor quality of the voice'
      },
      {
        TYPE_ID: '2',
        DETAIL_ID: '3',
        TYPE_SORT: '3',
        DETAIL_NAME: 'Probelm'
      },
      {
        TYPE_ID: '2',
        DETAIL_ID: '4',
        TYPE_SORT: '4',
        DETAIL_NAME: 'Bad experience'
      }
      ]
    },
    contactUs: {
      t1: 'ADONKI On WeChat',
      tips1: '1. Save the QR code and launch your WeChat app.',
      tips2: '2. Tap the “+” button in the top right-hand corner, and tap “Scan QR Code”. ',
      tips3: '3. Scan the QR code and view our official account right away.',
      btn: 'Save QR code'
    },
    bindICCID: {
      payment: {
        redemSuccess: 'Success',
        redemFail: 'Fail',
        confirm: 'Confirm'
      },
      head: 'Redeem HK  Number',
      label: {
        iccid: 'ICCID ',
        iccidWhere: '（SIM numbers - 20 digits）',
        pin: 'PIN Code',
        verifyPin: 'PIN Code （6 digits Code)',
        pinWhere: 'Find the 6-digit PIN code on the SIM card.',
        canNotFindPin: 'Unable to use PIN code?',
        canNotUsePinTips1: 'If you have lost your PIN code, please contact our customer service hotline: (852) 6469 6649',
        canNotUsePinTips2: '(Monday to Friday, 9:00 am to 6:00 pm) .',
        sysErrorTips: 'The system is busy now, please try again later or contact our customer service.',
        exchangeSuccess: 'Success! '
      },
      btn: {
        confirm: 'Confirm',
        exchange: 'Confirm'
      },
      inputTips: {
        iccid: 'Input 20-digit ICCID number',
        pin: 'Input 6-digit PIN code '
      },
      whatIccidTips: {
        title: 'What\'s ICCID？',
        tips: 'There is a 20-digit ICCID code printed on the SIM card.'
      },
      whatPinTips: {
        title: 'Where\'s PIN code?',
        tips: 'As shown in the red box above, the 6-digit PIN code is printed on the SIM card. Please enter the PIN code for verification.'
      }
    }
  },
  delUserData: {
    head: 'Clear user data',
    stepList: ['Enter Email', '->Verify Email', '->Confirm Delete', '->Data Cleanup'],
    esT1: 'App Name: eSender',
    esT2: 'Developer: Multibyte Info Technology Ltd.',
    gsT1: 'App Name: Travel Call',
    gsT2: 'Developer: ADONKI LIMITED',
    label1: 'Please enter your account email:',
    label2: 'Explanation: This email is a valid email address for you when registering your account',
    label3: 'Please enter the verification code:',
    label4: 'We need to verify your identity and have sent the verification code to:',
    label5: 'Please enter the verification code within 10 minutes',
    label6: 'Verification passed, are you sure you want to delete the account?',
    label7: 'and related data?',
    label8: 'Once confirmed, your account and data will be permanently deleted.',
    label9: 'Your account and data have been cleared. Thank you again for using our product. If you need to use our product again, please register again.',
    inputTip1: 'Please enter the correct email',
    inputTip2: 'Please enter the correct verification code',
    fail1: 'Verification information transmission failed, please contact administrator',
    fail2: 'Verification code verification failed, please contact administrator',
    fail3: 'Clearing user data failed, please contact administrator',
    btn: {
      back: 'Back',
      next: 'Next',
      prev: 'Prev',
      confirm: 'Confirm',
      cancel: 'Cancel',
      complete: 'Complete'
    }
  },
  notice: {
    head: 'Уведомление',
    unRead: 'Непрочитанные',
    read: 'Прочитано',
    readALL: 'Читать полностью',
    empty: 'Пустой',
    latestNews: 'Последние новости',
    noMore: ' Нет. ',
    warn: 'Ошибка получения списка сообщений',
    more: 'Больше',
    del: 'Дель',
    menu: {
      all: 'Все'
    }
  },
  brandHKNew: {
    title: 'New HK Number Registration',
    tips1: 'New Number launch, limited supply.',
    tips2: 'No SIM card service, App and WeChat receive text messages, Apps can be called out/in',
    tips3: 'Numbers purchased separately on the app cannot receive text messages on WeChat.',
    attention: 'Attention',
    attentionTips1: 'Chinese Hong Kong mobile phone number requires [real-name authentication] to provide services. According to local regulations, a valid Chinese Hong Kong ID card/Chinese Macau ID card/Hong Kong and Macau Pass/ Taiwan Compatriot Permit/ Passport, etc. must be provided. Mainland Chinese resident ID cards cannot undergo real name authentication. Please confirm if you have the above documents.[Yes Or No]',
    attentionTips2: 'This plan for Hong Kong numbers only ensures non reusable numbers and only provides communication services. It does not guarantee the success of any platform or app registration.',
    attentionTips3: 'If due to personal issues, it is not to complete the real name registration, HK$20 estimated number usage fee will be deducted when processing the refund.',
    btn1: 'No',
    btn2: 'Yes',
    btn3: 'No',
    btn4: 'Yes',
    number: {
      title: 'Please choose your favorite number',
      content: 'Other choices',
      selectTip: '(Can choose once only)',
      tip: 'Please choose number',
      warn: 'Fail to choose number',
      tipTitle: 'Restrict purchase',
      tipContent: 'Your application has reached the upper limit. Each account can register at least 1 eSender China number and 2 eSender Hong Kong numbers.',
      noNumberTips1: 'New Hong Kong phone numbers are out of stock! ',
      noNumberTips2: 'Please contact our customer service.'
    },
    member: {
      title: 'No SIM card',
      content: 'The Telecommunications Regulation has taken effect on 1 September 2021 to implement Real-name Registration Program of Hong Kong SIM cards. Protecting the security of telecommunications services, the new regulation has to prevent and assist the investigation of crimes involving the use of telephone prepaid SIM cards.',
      userlabel: 'User information',
      userTip: 'Input name',
      userWarn: 'Please input name',
      mobileTip: 'Input contact number',
      mobileWarn: 'Please input valid mobile number',
      codeLabel: 'Promotion code',
      codeTip: 'Promotion code(if any)',
      codeWarn: 'Please enter valid promotion code',
      codeOk1: 'Promotion offer is applied',
      codeOk2: ' valid day',
      useCodeTip: 'The discount code is invalid. Continue to purchase?',
      useBut: 'continue',
      cancleUseBut: 'cancel',
      mobilePrefixTitle: 'Select the phone area code',
      mobilePrefixList: [
        {name: 'Hong Kong SAR (China)（+852）', value: '852'},
        {name: 'China（+86）', value: '86'},
        {name: 'Macau(China)（+853）', value: '853'},
        {name: 'Taiwan (China)（+886）', value: '886'},
        {name: 'United States / Canada（+1）', value: '1'},
        {name: 'UK（+44）', value: '44'},
        {name: 'Malaysia（+60）', value: '60'},
        {name: 'Australia（+61）', value: '61'},
        {name: 'Philippines（+63）', value: '63'},
        {name: 'Indonesia（+62）', value: '62'},
        {name: 'Singapore（+65）', value: '65'},
        {name: 'Thailand（+66）', value: '66'},
        {name: 'Japan（+81）', value: '81'},
        {name: 'South Korea（+82）', value: '82'},
        {name: 'Vietnam（+84）', value: '84'},
        {name: 'France（+33）', value: '33'},
        {name: 'Italy（+39）', value: '39'},
        {name: 'Germany（+49）', value: '49'},
        {name: 'Other', value: ''}
      ]
    },
    confirm: {
      title: 'Confirm Order',
      tetle2: 'No SIM card service',
      code: 'Promotion code',
      price: 'Total amount',
      plan: 'Package code',
      username: 'Input name',
      mobile: 'Contact number',
      add: 'add',
      day: 'valid day',
      update: 'Update'
    },
    letter: {
      title: '“eSender” Service Agreement (Hong Kong Number)',
      statement: 'DECLARATION',
      statementInfo: 'I have read and understand the Guangzhou Multibyte Info Technology Limited’s Privacy Policy and Personal Information Collection Statement, Point No.2 “Personal Information Collection Statement”. Please “√”the appropriate box in below.',
      statementDetail1: 'I agree with the above terms and conditions.',
      statementDetail4: 'I agree with Multibyte in Hong Kong to use my personal data for direct marketing services products.',
      statementDetail2: 'I agree with Multibyte in Hong Kong to use my personal data for direct marketing services products.',
      statementDetail3: 'I agree with Multibyte in Hong Kong to use my personal data, but only for Multibyte Hong Kong contract as well as by the direct provision of telecommunications services. (Including but not limited to, mobile voice and data services, international roaming/long distance telephone services, such as product promotions).',
      content: [
        'The above service provides receiving and sending SMS through eSender WeChat Official Account and/or eSender APP. Guangzhou Multibyte Info Technology Limited ( ”Multibyte” ) can also provide SIM card, MNP, voice and data services. SIM card delivery fee will be charged. Voice and data services are applicable for the accounts using the package and fees will be charged for sending SMS.',
        'Sending SMS is only applicable for the accounts using the package and fees will be charged for sending SMS. For details, please visit Multibyte’s website www.multi-byte.com.',
        'Before the expiry date, SMS alert will be sent SMS to the Hong Kong Number of the registered eSender service. Customer can check the message at the eSender Official Account and/or eSender APP. Customer can recharge and extend the expiry date via eSender Official Account, eSender APP or Multibyte’s web site, www.multi-byte.com.',
        'The service will be suspended on the expiry date. Customer can reactivate the service by recharge on the eSender Official Account, eSender APP or Multibyte’s web site.',
        'If the service is suspended over 3 days due to any reason, the eSender Hong Kong Number will be given to Multibyte.',
        'The eSender Hong Kong Number can be changed.',
        'Refund is not applicable for the suspension fur to all reasons.',
        'All offers are non-transferrable, non-refundable and cannot be redeemed to other service or products.',
        'The Telecommunications (Registration of SIM Cards) Regulation (the "Regulation") has taken effect to implement the Real-name Registration Programme for Subscriber Identification Module (SIM) Cards ("Real-name Registration Programme"). Protecting the security of telecommunications services, the new regulation has to prevent and assist the investigation of crimes involving the use of telephone prepaid SIM cards. According to this regulation, registered users are divided into personal and corporate users. Individual users are required to provide information as contained in their identification documents (Hong Kong Identity Card or other acceptable identification documents such as visitors travel documents) including name, date of birth, number of the identification document and its photo for registration. A company or corporate which would like to register as SIM card users are required to provide business registration information and specify a representative or a responsible person and provide the personal information of that person. A person below 16 years old who needs to register for SIM card services will require the endorsement of an adult. The telecommunications operator will also register the information of that adult.',
        'This Statement is made by Guangzhou Multibyte Info Technology Limited in accordance with the General Terms and Conditions. For details, please visit Multibyte’s web site, www.multi-byte.com.',
        'The provision of personal data is voluntary. If you do not provide sufficient information, you may not be able to apply the eSender service. Multibyte may use your personal data mentioned above for marketing the goods and/or services. Enabling Multibyte to use and retain the personal data provided by you to perform any obligations on interconnection or conform with other industry practices, or to comply with any requests stipulated by governmental or regulatory authorities.',
        'Guangzhou Multibyte Info Technology Limited reserves the right to amend the terms and conditions of this event registration. All matters and disputes in relation to the registration will be subject to the final decision of Multibyte Info Technology Limited.'
      ],
      warn: 'Please agree to the relevant terms.'
    }
  },
  polPlan: {
    title: 'POL mobile number registration',
    registerErr: 'Pre-registered POL number fail,Please try again in 10 minutes.',
    registerOk: 'Pre-registered POL number success',
    plan: {
      title: 'POL mobile number',
      content: 'No SIM card, WeChat and App receive SMS.',
      content2: 'Numbers purchased separately on the app cannot receive text messages on WeChat.',
      selectTip: 'Please select the package...',
      tip: 'Please select the package',
      warn: 'No packages are currently available for sale'
    },
    number: {
      title: 'Please choose your favorite number',
      content: 'Other choices',
      selectTip: '(Can choose once only)',
      tip: 'Please choose number',
      warn: 'Fail to choose number',
      tipTitle: 'Restrict purchase',
      tipContent: 'Your application limit has been reached. Every account can apply ONLY ONE POL mobile number.'
    },
    member: {
      title: 'POL mobile number',
      content: 'POL mobile number plan is a SIM-free plan. It is limited to use APP or WeChat receive SMS. (The plan does not include any calling, SMS and data service)',
      userlabel: 'User information',
      userTip: 'Input name',
      userWarn: 'Please input name',
      mobileTip: 'Input contact number',
      mobileWarn: 'Please input valid mobile number',
      codeLabel: 'Promotion code',
      codeTip: 'Promotion code(if any)',
      codeTip2: 'Input the promotion code can be add an additional 15 days after the number successful activated.',
      codeWarn: 'Please enter valid promotion code',
      codeOk1: 'Promotion offer is applied',
      codeOk2: ' valid day',
      useCodeTip: 'The discount code is invalid. Continue to purchase?',
      useBut: 'continue',
      cancleUseBut: 'cancel',
      mobilePrefixTitle: 'Select the phone area code',
      mobilePrefixList: [
        {name: 'Hong Kong SAR (China)（+852）', value: '852'},
        {name: 'China（+86）', value: '86'},
        {name: 'Macau(China)（+853）', value: '853'},
        {name: 'Taiwan (China)（+886）', value: '886'},
        {name: 'United States / Canada（+1）', value: '1'},
        {name: 'UK（+44）', value: '44'},
        {name: 'Malaysia（+60）', value: '60'},
        {name: 'Australia（+61）', value: '61'},
        {name: 'Philippines（+63）', value: '63'},
        {name: 'Indonesia（+62）', value: '62'},
        {name: 'Singapore（+65）', value: '65'},
        {name: 'Thailand（+66）', value: '66'},
        {name: 'Japan（+81）', value: '81'},
        {name: 'South Korea（+82）', value: '82'},
        {name: 'Vietnam（+84）', value: '84'},
        {name: 'France（+33）', value: '33'},
        {name: 'Italy（+39）', value: '39'},
        {name: 'Germany（+49）', value: '49'},
        {name: 'Other', value: ''}
      ]
    },
    confirm: {
      title: 'Confirm Order',
      tetle2: 'POL mobile number',
      code: 'Discount code',
      price: 'Total',
      plan: 'Plan',
      username: 'Enter name',
      mobile: 'Mobile number',
      add: 'Add',
      day: 'days vaild',
      update: 'Update'
    },
    letter: {
      title: '“eSender HK” Service Agreement (POL mobile number)',
      statement: 'DECLARATION',
      statementInfo: 'I have read and understood “Multi-byte” Privacy Policy and Personal Information Collection Statement - No.2 Personal Information Collection. Please tick in the appropriate box:',
      statementDetail1: 'I understand and accept the above Terms and Conditions. ',
      statementDetail4: 'I understand and accept that the “Multi-byte” will use of my personal data in Promotion or Direct Marketing. ',
      statementDetail2: 'I understand and accept that the “Multi-byte” will use of my personal data which limit to service continue arrangements and telecommunications services directly provided by “Multi-byte” (including but not limited to mobile voice, mobile data services, international roaming services/IDD service product promotion information). ',
      statementDetail3: 'I am not accept that the “Multi-byte” will use of my personal data in Promotion or Direct Marketing. ',
      content: [
        'The above service is provided in the WeChat “eSender HK" official account linking to POL mobile number SMS service.',
        '“Multi-byte” will send a message to the customer who has registered the POL mobile number as a reminder upon expiry of the service. Customers can check the usage within the validity period via WeChat Official Account "eSender HK" with the POL mobile number which has already linked up with WeChat. You may extend service validity by recharge it via WeChat Official Account at any time before its expiry.',
        'Upon the expiry of the service, it will be suspended without prior notice. Customers can make payment and reactivate the service on WeChat "eSender HK" official account. All SMS will not be reissued during the suspension period.',
        'Customer agrees that the assigned POL mobile number return to “Multi-byte” if the service is suspended more than 3 days or its terminated for any reason.',
        'The POL mobile numbers on service plans cannot be changed.',
        'The prepaid fee will not be refunded if the service is terminated for any reason.',
        'All offers are not transferable, cash refundable and/or non-exchangeable for other services and/or products.',
        'This service is subject to the 《General Terms and Conditions》of “Multi-byte”. Please visit the Multi-byte website (www.multi-byte.com) for the details.',
        '“Multi-byte” is not responsible for the accuracy of such information which voluntarily provided by you. We may not be able to provide or continue to provide our services to you if your personal data is incomplete or incorrect. “Multi-byte” has the right to use the above information to provide you with services, notify you of preferential promotions, and if necessary, disclosed to third parties for credit review, debt recovery, market research, and other purposes disclosed and used with your consent as required by law or in compliance with the requirements of recognized government agencies.',
        'Multibyte Info Technology Limited reserves the right to amend the terms and conditions of this event registration. All matters and disputes in relation to the registration will be subject to the final decision of Guangzhou Multibyte Info Technology Limited.'
      ],
      warn: 'Please agree to the relevant terms.'
    }
  },
  usPlan: {
    title: 'US mobile number registration',
    registerErr: 'Pre-registered US number fail',
    registerOk: 'Pre-registered US number success',
    plan: {
      title: 'US mobile number',
      content: 'No SIM card, App receive SMS.',
      content2: 'Numbers purchased separately on the app cannot receive text messages on WeChat.',
      selectTip: 'Please select the package...',
      tip: 'Please select the package',
      warn: 'No packages are currently available for sale'
    },
    member: {
      title: 'US mobile number',
      content: 'US mobile number plan is a SIM-free plan. It is limited to use APP or WeChat receive SMS. (The plan does not include any calling, SMS and data service)',
      userlabel: 'User information',
      userTip: 'Input name',
      userWarn: 'Please input name',
      mobileTip: 'Input contact number',
      mobileWarn: 'Please input valid mobile number',
      codeLabel: 'Promotion code',
      codeTip: 'Promotion code(if any)',
      codeTip2: 'Input the promotion code can be add an additional 15 days after the number successful activated.',
      codeWarn: 'Please enter valid promotion code',
      codeOk1: 'Promotion offer is applied',
      codeOk2: ' valid day',
      useCodeTip: 'The discount code is invalid. Continue to purchase?',
      useBut: 'continue',
      cancleUseBut: 'cancel',
      mobilePrefixTitle: 'Select the phone area code',
      mobilePrefixList: [
        {name: 'Hong Kong SAR (China)（+852）', value: '852'},
        {name: 'China（+86）', value: '86'},
        {name: 'Macau(China)（+853）', value: '853'},
        {name: 'Taiwan (China)（+886）', value: '886'},
        {name: 'United States / Canada（+1）', value: '1'},
        {name: 'UK（+44）', value: '44'},
        {name: 'Malaysia（+60）', value: '60'},
        {name: 'Australia（+61）', value: '61'},
        {name: 'Philippines（+63）', value: '63'},
        {name: 'Indonesia（+62）', value: '62'},
        {name: 'Singapore（+65）', value: '65'},
        {name: 'Thailand（+66）', value: '66'},
        {name: 'Japan（+81）', value: '81'},
        {name: 'South Korea（+82）', value: '82'},
        {name: 'Vietnam（+84）', value: '84'},
        {name: 'France（+33）', value: '33'},
        {name: 'Italy（+39）', value: '39'},
        {name: 'Germany（+49）', value: '49'},
        {name: 'Other', value: ''}
      ],
      contactInfo: 'Contact information',
      firstNameTip: 'First Name',
      firstNameWarn: 'Please input First Name',
      lastNameTip: 'Last Name',
      lastNameWarn: 'Please input Last Name',
      emailTip: 'Input correct email',
      emailWarn: 'Please input correct email'
    },
    confirm: {
      title: 'Confirm Order',
      title2: 'US mobile number',
      code: 'Discount code',
      price: 'Total',
      plan: 'Plan',
      username: 'Enter name',
      mobile: 'Mobile number',
      add: 'Add',
      day: 'days vaild',
      update: 'Update',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email'
    },
    letter: {
      title: '「易博通eSender」服務計劃同意書(美國號碼）',
      statement: '個人聲明',
      statementInfo: '我已經閱讀及瞭解博元訊息科技有限公司私隱政策及個人資料收集聲明，第2條“收集個人資料”的規定，請在以下適當空格加上【√】號：',
      statementDetail1: '本人同意以上條款及細則。',
      statementDetail4: '本人同意博元使用本人的個人资料直接促銷任何服務產品。',
      statementDetail2: '本人同意博元使用本人的個人资料，但僅限於延續服務安排及由博元直接提供的电訊服务(包括但不限於流動語音，數據服務，國際漫遊服務/長途電話服務產品促銷資訊)。',
      statementDetail3: '本人不同意博元使用任何本人的個人资料促銷用途。',
      content: [
        '以上服務提供於微信"易博通 eSender"公眾號綁定美國號碼查閱短訊服务。',
        '當服務有效期屆滿前，博元將發送訊息予客戶登記之美國號碼提示客戶，客戶可於已於綁定美國號碼的微信"易博通香港eSenderHK"公眾號查閱，並可於有效期屆滿前自行於本公眾號繳費以延長服務有效期。',
        '當服務有效期完結時，服務會被暂停。客戶可於微信"易博通 eSender "App繳費並重啟服務。暫停期間之訊息將不獲補發。',
        '如服务因任何原故而停用超过3日或终止服务，客戶同意屆時必須放棄該分配的英國號碼並 歸還予博元。',
        '服務計劃中的美國號碼不能更改。',
        '如服務因任何原故而停用，所预繳之费用將不獲退還。',
        '任何優惠不得自由轉讓、退回現金及/或不可兌换其他服务及/或產品。',
        '此服務受博元訊息科技有限公司的《一般條款及條件》約束，詳情請瀏覽博元網頁。 ',
        '上述資料為閣下自願提供，如有資料錯漏，博元訊息可能未能為閣下提供所申请之服務，博元訊息有權使用上述資料為閣下提供服務，通知閣下優惠推廣活動，如有需要，披露予第三方作信用覆核、追討债務、市場研究、及在法律規定下或遵從被認可之政府機關要求下披露及經閣下同意使用之其他用途。',
        '博元訊息科技有限公司保留更改本服务計劃同意書之條款及條件與優惠之權利，恕不另行通知，遇有任何爭議，概以博元之決定為最終決定，客户須受彼等約束。'
      ],
      warn: '請同意有關條款'
    }
  },
  esContactUs: {
    head: 'Contact Us',
    onlineTitle: 'Online Service',
    online1: 'WeChat eSender',
    online2: 'Facebook eSender',
    online3: 'WhatsApp',
    telTitle: 'Customer Service Hotline',
    tel1: 'Mainland China (86) 400-888-4333',
    tel2: 'Hong Kong, China (852) 21568888',
    tel3: 'Russian : eSender.org',
    quesTitle: 'FAQs',
    ques1: 'Do you have any common query questions? You may get answers from it.',
    quesBtn: 'Go to FAQ',
    sendTitle: 'Send message via WeChat',
    send1: 'Should you have any inquiries,you can contact us in WeChat.',
    sendBtn: 'Go to WeChat'
  },
  realNameInfo: {
    head: 'Запрос о реальном имени',
    choosePhone: 'Выберите номер',
    balance: 'Остаток',
    authPass: 'Yes',
    authFail: 'No',
    auditing: 'Process',
    auditing2: 'Process',
    unAuth: 'No',
    unAuthStatus: 'No realName ,No Use',
    numberInfo: 'Номерные данные',
    noPhoneTips: 'У вас нет номера, сначала купите номер',
    status: 'Статус',
    normal: 'Нормально.',
    expired: 'Отказ',
    active: 'Using',
    numExpired: 'Expired',
    notRealName: 'No RealName',
    noNumber: 'Нет номера',
    endDate: 'Дата истечения',
    notApplicable: 'Не применимо',
    certNo: 'Номер документа',
    product: 'Атрибуты продукта',
    licenseNo: 'Номер лицензии',
    idType: 'Тип сертификата',
    realNameFlag: 'Состояние реального имени',
    customerLine: 'Телефон службы поддержки',
    registerTime: 'Время подключения к сети',
    mobile: 'Переместить',
    operation: 'Оператор',
    customerName: 'Имя',
    expiredTime: 'Время истечения срока',
    customerStatus: 'Статус пользователя',
    nodata: 'Не найдено',
    tips: '*Доступ только к номерам материкового Китая'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/ru.js